//角6、地弹簧2
import makerjs from "makerjs";
import RectangleMark from "./RectangleMark";

//已知劣弧上两点坐标及半径，求圆心坐标劣弧圆心点坐标。
function optimizedCirclepoint(x1,y1,x2,y2,radius) {
   var r=radius;
  var x_mid=(x1+x2)/2,y_mid=(y1+y2)/2,k=(y2-y1)/(x2-x1);
  var m=-1/k,A=1+(m*m);
  var B=2*m*(y_mid-m*x_mid-y1)-2*x1;
  var C=(y_mid-m*x_mid-y1)*(y_mid-m*x_mid-y1)+(x1*x1)-(r*r);
  var x01=(-B+Math.sqrt((B*B)-4*A*C))/2*A;
  var x02=(-B-Math.sqrt((B*B)-4*A*C))/2*A;
  var y01=m*(x01-x_mid)+y_mid;
  var y02=m*(x02-x_mid)+y_mid;
  // var C1=(x2*x2-x1*x1+y2*y2-y1*y1)/(2*(x2-x1)),C2=(y2-y1)/(x2-x1);
  // var A=(C2*C2+1);
  // var B=(2*x1*C2)-(2*C1*C2)-(2*y1);
  // var C=(x1*x1)-(2*x1*C1)+(C1*C1)+(y1*y1)-(r*r);
  // var y=(-B-Math.sqrt((B*B)-4*A*C))/2*A;
  // var x=C1-(C2*y);
  console.log("x1,y1,x2,y2,r,=",x1,y1,x2,y2,r);
  console.log("x_mid,y_mid,x2,y2,k,m=",x_mid,y_mid,x2,y2,k,m);
  console.log("k,A,B,C=",k,A,B,C);
  console.log("x01,y01,x02,y02=",x01,y01,x02,y02);
  return {
    x01,y01,x02,y02
  }
}
/**
 * 相离两个圆 已经两个圆圆心坐标 求两圆最近点坐标
 * 定两个相离的圆C1和C2；圆心坐标分别为(x1,y1)和(x2,y2),半径分别为 r1和r2.
 * 由于两圆相离，最近点位于两圆心的连线上。以下是求解步骤：
 * 1. 计算圆心距离
 * 首先计算两圆心的距离d;
 * d=Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1));
 * 2. 确定最近点方向
 * 两圆的最近点位于从C1到C2的连线上。设最近点为P，则P的坐标可以通过以下公式计算：
 * P=(x1+r1*(x2-x1)/d,y1+r1*(y2-y1)/d)
 * P=(x2-r2*(x2-x1)/d,y2-r2*(y2-y1)/d)
 * 这两个公式分别表示从C1出发向外延伸r1距离，或从C2出发向内延伸r2距离。
 * 3. 验证结果
 * 由于两圆相离，最近点P应满足：
 * 距离（P,C1）=r1 且 距离 (P,C2)=d-r2
 * 示例假设C1的圆心为(0,0),半径r1=2,C2的圆心为（5,0）,半径r2=1;
 * 1、计算圆心距离：
 * d=Math.sqrt((5-0)*(5-0)+(0-0)*(0-0))=5
 * 2、计算最近点P;
 * P=(0+2/5*5,0+2/5*0)=(2,0)
 * 验证：
 * 距离（P,C1）=Math.sqrt((2-0)*(2-0)+(0,0)*(0,0))=2=r1;
 * 距离（P,C2）=Math.sqrt((2-5)*(2-5)+(0,0)*(0,0))=3=d-r2;
 * 
 * 
 */
 function getCalculatingDistance(x1,y1,x2,y2,r1,r2){
  var d=Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1));
  var X1=x1+r1*(x2-x1)/d,Y1=y1+r1*(y2-y1)/d,
  X2=x2-r2*(x2-x1)/d,Y2=y2-r2*(y2-y1)/d,
  X3=x2+r2*(x2-x1)/d,Y3=y2+r2*(y2-y1)/d;
  var arr={d,X1,Y1,X2,Y2,X3,Y3};
  return arr;
};

//两个数组  对比 取相同部分
function getCommonAll(arr1,frame) {
  var arr2=["Rectangle","TypeCorner_myFloorSpring2HA","TypeCorner_myFloorSpring2HC","TypeCorner_myFloorSpring2HG","TypeCorner_myFloorSpring2HI","TypeCorner_myFloorSpring2HAC","TypeCorner_myFloorSpring2HAG","TypeCorner_myFloorSpring2HAI","TypeCorner_myFloorSpring2HCG","TypeCorner_myFloorSpring2HCI","TypeCorner_myFloorSpring2HGI","TypeCorner_myFloorSpring2HACG","TypeCorner_myFloorSpring2HACI","TypeCorner_myFloorSpring2HCGI","TypeCorner_myFloorSpring2HAGI","TypeCorner_myFloorSpring2HACGI"];
  console.log("是否调用此函数！");
  var result = [];
  for (const item1 of arr1) {
    for (const item2 of arr2) {
      if (item1 === item2) result.push(item1);
    }
  }
  if (result[0] == frame) {
        result.shift();//去掉数组第一个元素  
    
  }
  console.log("是否调用此函数！",result);
  console.log("是否调用此函数！",typeof(result));
  console.log("是否调用此函数！",result[0]);
  return result;
};
function changeArea(num){
  var areaPoint;
  switch(num){
 case "1": areaPoint = "A";break;
 case "2": areaPoint = "B";break;
 case "3": areaPoint = "C";break;
 case "4": areaPoint = "D";break;
 case "5": areaPoint = "E";break;
 case "6": areaPoint = "F";break;
 case "7": areaPoint = "G";break;
 case "8": areaPoint = "H";break;
 case "9": areaPoint = "I";break;
}
return areaPoint;
};
function showArea(data,outParam){ 
  console.log("data|||ObliqueAngle$$$$$$$$$$||||showArea====",data);
  var x=outParam.glassW*1,y=outParam.glassH*1,glassW=outParam.glassW*1,glassH=outParam.glassH*1;
  console.log("data==data.area===",data.area);
  console.log("data==typeof(data)===",typeof(data));
  console.log("data==data.length===",data.length);
  console.log("data[0]==data.length===",data[0]);
  console.log("data[1]==data.length===",data[1]);
//console.log("myObj=showArea=",obj);  
    var properNum=objHasOwnProperty(data);
    console.log("properNum===",properNum);
    var arrData=[];
    var arrArea=[];
    var arrAreaNum=[];
    for (let key in data) {
      console.log("测试key0=", key);
            if (data.hasOwnProperty(key)&& key!=="0") {              
              console.log("测试key0=", key);
              if (key !== "Rectangle") {
                console.log("myData=", data);
              console.log("测试key2=", key);
              console.log("data[key].shape=", data[key].shape);
              console.log("data[key].area=", data[key].area);            
              arrData.push(data[key]);
              arrArea.push(changeArea(data[key].area));
              arrAreaNum.push(data[key].area);
              }         
            }
          }    
          console.log("arrData=",arrData);     
         var xa = 0, ya = y,xc = x , yc = y ,xg = 0, yg = 0,xi = x , yi = 0,
         da=0,wa=0,w1a=0,w2a=0,ha=0,h1a=0,ra=0,r1a=0,
         dc=0,wc=0,w1c=0,w2c=0,hc=0,h1c=0,rc=0,r1c=0,
         dg=0,wg=0,w1g=0,w2g=0,hg=0,h1g=0,rg=0,r1g=0,
         di=0,wi=0,w1i=0,w2i=0,hi=0,h1i=0,ri=0,r1i=0,
         xawx1=0,xawy1=0,xawx2=0,xawy2=0,xawx3=0,xawy3=0,
         xcwx1=0,xcwy1=0,xcwx2=0,xcwy2=0,xcwx3=0,xcwy3=0,
         xgwx1=0,xgwy1=0,xgwx2=0,xgwy2=0,xgwx3=0,xgwy3=0,
         xiwx1=0,xiwy1=0,xiwx2=0,xiwy2=0,xiwx3=0,xiwy3=0; 
         /**
          *  var xawx1 = xa+h, xawy1 = ya,//A位置角1坐标
        xawx2 = xa + h, xawy2 = ya -w ,//A位置角2坐标
        xawx3 = xa , xawy3 = ya- w2,//A位置角3坐标
  
        xcwx1 = xc - h, xcwy1 = yc,//C位置角1坐标
        xcwx2 = xc - h, xcwy2 = yc - w,//C位置角2坐标
        xcwx3 = xc, xcwy3 = yc - w2,//C位置角3坐标
  
        xgwx1 = xg + h, xgwy1 = yg,//G位置角1坐标
        xgwx2 = xg + h, xgwy2 = yg + w,//G位置角2坐标
        xgwx3 = xg, xgwy3 = yg + w2,//G位置角3坐标
  
        xiwx1 = xi - h, xiwy1 = yi,//I位置角1坐标
        xiwx2 = xi - h, xiwy2 = yi + w,//I位置角2坐标
        xiwx3 = xi, xiwy3 = yi + w2;//I位置角3坐标
          * 
          * 
          */
         if(x>y){
          for(var i = 0; i < arrAreaNum.length; i++){
            var areaNums=arrAreaNum[i];
            var r1=arrData[i].R*1,d=arrData[i].D*1,r=d/2,w=arrData[i].W*1,w1=arrData[i].W1*1,w2=arrData[i].W2*1,h=arrData[i].H*1,h1=arrData[i].H1*1;
            switch(areaNums){
               case "1":   
              // console.log("switch objA.xawx",xawx);
              da=d,wa=w,w1a=w1,w2a=w2,ha=h,h1a=h1,ra=r,r1a=r1,         
              xawx1 = xa+h, xawy1 = ya,//A位置角1坐标
        xawx2 = xa + h, xawy2 = ya -w ,//A位置角2坐标
        xawx3 = xa , xawy3 = ya- w2;//A位置角3坐标
                break;
               case "3":  
               dc=d,wc=w,w1c=w1,w2c=w2,hc=h,h1c=h1,rc=r,r1c=r1,      
               xcwx1 = xc - h, xcwy1 = yc,//C位置角1坐标
               xcwx2 = xc - h, xcwy2 = yc - w,//C位置角2坐标
               xcwx3 = xc, xcwy3 = yc - w2;//C位置角3坐标
               break;
               case "7":        
               dg=d,wg=w,w1g=w1,w2g=w2,hg=h,h1g=h1,rg=r,r1g=r1,          
               xgwx1 = xg + h, xgwy1 = yg,//G位置角1坐标
               xgwx2 = xg + h, xgwy2 = yg + w,//G位置角2坐标
               xgwx3 = xg, xgwy3 = yg + w2;//G位置角3坐标
               break;
               case "9":  
               di=d,wi=w,w1i=w1,w2i=w2,hi=h,h1i=h1,ri=r,r1i=r1,          
               xiwx1 = xi - h, xiwy1 = yi,//I位置角1坐标
               xiwx2 = xi - h, xiwy2 = yi + w,//I位置角2坐标
               xiwx3 = xi, xiwy3 = yi + w2;//I位置角3坐标
               break;
             }
          }
         }else{
          for(var i = 0; i < arrAreaNum.length; i++){
            var areaNums=arrAreaNum[i];
            var r1=arrData[i].R*1,d=arrData[i].D*1,r=d/2,w=arrData[i].W*1,w1=arrData[i].W1*1,w2=arrData[i].W2*1,h=arrData[i].H*1,h1=arrData[i].H1*1;
            switch(areaNums){
               case "1":   
              // console.log("switch objA.xawx",xawx);
              da=d,wa=w,w1a=w1,w2a=w2,ha=h,h1a=h1,ra=r,r1a=r1,         
              xawx1 = xa, xawy1 = ya - h,//A位置角1坐标
              xawx2 = xa + w, xawy2 = ya - h,//A位置角2坐标
              xawx3 = xa + w2, xawy3 = ya;//A位置角3坐标
                break;
               case "3":  
               dc=d,wc=w,w1c=w1,w2c=w2,hc=h,h1c=h1,rc=r,r1c=r1,      
               xcwx1 = xc, xcwy1 = yc - h,//C位置角1坐标
            xcwx2 = xc - w, xcwy2 = yc - h,//C位置角2坐标
            xcwx3 = xc - w2, xcwy3 = yc;//C位置角3坐标
               break;
               case "7":        
               dg=d,wg=w,w1g=w1,w2g=w2,hg=h,h1g=h1,rg=r,r1g=r1,          
               xgwx1 = xg, xgwy1 = yg + h,//G位置角1坐标
               xgwx2 = xg + w, xgwy2 = yg + h,//G位置角2坐标
               xgwx3 = xg + w2, xgwy3 = yg;//G位置角3坐标
               break;
               case "9":  
               di=d,wi=w,w1i=w1,w2i=w2,hi=h,h1i=h1,ri=r,r1i=r1,          
               xiwx1 = xi, xiwy1 = yi + h,//I位置角1坐标
               xiwx2 = xi - w, xiwy2 = yi + h,//I位置角2坐标
               xiwx3 = xi - w2, xiwy3 = yi;//I位置角3坐标
               break;
             }
          }
         }    
      
          arrArea=arrArea.sort();
          arrArea=arrArea.join("");
        var whMark={};
         var paramCoordinate = {da,wa,w1a,w2a,ha,h1a,ra,r1a,dc,wc,w1c,w2c,hc,h1c,rc,r1c,dg,wg,w1g,w2g,hg,h1g,rg,r1g,di,wi,w1i,w2i,hi,h1i,ri,r1i,xa, ya, xawx1, xawy1,xawx2, xawy2,xawx3, xawy3,xc, yc, xcwx1, xcwy1, xcwx2,xcwy2,xcwx3,xcwy3,xg, yg, xgwx1, xgwy1, xgwx2, xgwy2,xgwx3, xgwy3,xi, yi, xiwx1, xiwy1, xiwx2, xiwy2, xiwx3, xiwy3,glassW,glassH}
          console.log("showArea===arrData=",arrData);
          console.log("showArea===arrArea=",arrArea);
          console.log("paramCoordinate===arrArea=",paramCoordinate);
          console.log("whMark===whMark=",whMark);
          var objData=[arrArea,paramCoordinate,whMark]; 
  
  return objData;
      };
function objHasOwnProperty(obj) {
        var count = 0;
        for (var i in obj) {
          if (obj.hasOwnProperty(i)) {
            count++;
          }
        }
        return count;
      };
//获取角的字符串判断是哪个角
function getStrs(area, strs) {
  console.log("是否调用此函数getStrs（）",strs);
  var indexN=strs.length-1;
  var arrA = [];
  var TA = strs[indexN].slice(25);
  TA = TA + area;
  arrA = Array.from(TA);
  console.log("是否调用此函数getStrs()arrA==", arrA)
  arrA = arrA.sort();
  arrA = arrA.join("");
  console.log("是否调用此函数getStrs()areaPoint arrA==", arrA)
  return arrA;
};
// 矩形等去角 连线函数
function creatFloorSpring2H(area, param) {
  console.log("是否调用此函数creatOneCorner（）");
  console.log("是否调用此函数creatOneCorner（）param=", param);
  var xa = param.xa, ya = param.ya, xawx1 = param.xawx1, xawy1 = param.xawy1, xawx2 = param.xawx2, xawy2 = param.xawy2, xawx3 = param.xawx3, xawy3 = param.xawy3,
    xc = param.xc, yc = param.yc, xcwx1 = param.xcwx1, xcwy1 = param.xcwy1, xcwx2 = param.xcwx2, xcwy2 = param.xcwy2, xcwx3 = param.xcwx3, xcwy3 = param.xcwy3,
    xg = param.xg, yg = param.yg, xgwx1 = param.xgwx1, xgwy1 = param.xgwy1, xgwx2 = param.xgwx2, xgwy2 = param.xgwy2, xgwx3 = param.xgwx3, xgwy3 = param.xgwy3,
    xi = param.xi, yi = param.yi, xiwx1 = param.xiwx1, xiwy1 = param.xiwy1, xiwx2 = param.xiwx2, xiwy2 = param.xiwy2, xiwx3 = param.xiwx3, xiwy3 = param.xiwy3,
    d = param.d, r = param.r, r1 = param.r1, w = param.w, w1 = param.w1, w2 = param.w2, h = param.h, h1 = param.h1,
    da = param.da,ra = param.ra,r1a = param.r1a,wa = param.wa,w1a = param.w1a,w2a = param.w2a,ha = param.ha,h1a = param.h1a,
    dc = param.dc,rc = param.rc,r1c = param.r1c,wc = param.wc,w1c = param.w1c,w2c = param.w2c,hc = param.hc,h1c = param.h1c,
    dg = param.dg,rg = param.rg,r1g = param.r1g,wg = param.wg,w1g = param.w1g,w2g = param.w2g,hg = param.hg,h1g = param.h1g,
    di = param.di,ri = param.ri,r1i = param.r1i,wi= param.wi,w1i = param.w1i,w2i = param.w2i,hi = param.hi,h1i = param.h1i,
    glassH=param.glassH,glassW=param.glassW,cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius,
    oAd=param.oAd,oAX1=param.oAX1,oAY1=param.oAY1,oAX2=param.oAX2,oAY2=param.oAY2,oAX3=param.oAX3,oAY3=param.oAY3,
    oCd=param.oCd,oCX1=param.oCX1,oCY1=param.oCY1,oCX2=param.oCX2,oCY2=param.oCY2,oCX3=param.oCX3,oCY3=param.oCY3,
    oGd=param.oGd,oGX1=param.oGX1,oGY1=param.oGY1,oGX2=param.oGX2,oGY2=param.oGY2,oGX3=param.oGX3,oGY3=param.oGY3,
    oId=param.oId,oIX1=param.oIX1,oIY1=param.oIY1,oIX2=param.oIX2,oIY2=param.oIY2,oIX3=param.oIX3,oIY3=param.oIY3;
console.log("glassH,glassW",glassH,glassW);
if(glassW*1<glassH * 1){
  console.log("长边在X轴￥￥￥￥￥");
  if (area == "A") {
    var myFloorSpring2H = {
      paths: {
        "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx3, xawy3]),
        "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
        "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
        "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
        "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
        "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
        "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
      }
    };
    var myFloorSpring2HCut = {
      paths: {
        "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
        "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
        "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
      }
    };
    //带引爆槽和标注
    var myFloorSpring2HCutM = {
      paths: {
        "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx3, xawy3]),
        "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
        "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
        "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
        "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
        "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
        "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
        "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
        "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
        "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
        // "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
      }
    };
    var myFloorSpring2HWaterCut0 = {
      paths: {
        "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]),
        "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
        "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
        "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
        "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
        "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
        "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),            
        "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      }
    };
    var myFloorSpring2HWaterCut = {
      paths: {
        "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]),
        "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
        "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
        "CircleDnA1": new makerjs.paths.Arc([oAX2, oAY2], [oAX3, oAY3], ra, false, false),//圆
        "CircleUpA2": new makerjs.paths.Arc([oAX3, oAY3],[oAX2, oAY2], ra, false, false),//圆
        "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
        "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
        "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),            
        "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
      }
    };
    var fillet1 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.EntryLineA, myFloorSpring2HWaterCut.paths.TopLeftLineAArc, cutFilletRadius);
    var fillet2 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopLeftLineAArc, myFloorSpring2HWaterCut.paths.arcAndLineA1, cutFilletRadius);
    var fillet3 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.arcAndLineA1, myFloorSpring2HWaterCut.paths.CircleDnA1, cutFilletRadius);
    var fillet4 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.CircleUpA2, myFloorSpring2HWaterCut.paths.arcAndLineA2, cutFilletRadius);
    var fillet5 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.arcAndLineA2, myFloorSpring2HWaterCut.paths.TopLeftLineAArcTow, cutFilletRadius); 
    myFloorSpring2HWaterCut.paths.fillet1 = fillet1;
    myFloorSpring2HWaterCut.paths.fillet2 = fillet2;
    myFloorSpring2HWaterCut.paths.fillet3 = fillet3;
    myFloorSpring2HWaterCut.paths.fillet4 = fillet4;
    myFloorSpring2HWaterCut.paths.fillet5 = fillet5;
  
  } else if (area == "C") {
    var myFloorSpring2H = {
      paths: {
        "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
        "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
        "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
        "TopRithgLineC": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
        "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xi, yi]),
        "BottomLineC": new makerjs.paths.Line([xi, yi], [xg, yg]),
        "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
      }
    };
    var myFloorSpring2HCutM = {
      paths: {
        "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
        "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
        "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
        "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
        "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
        "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
        "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
        "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
        "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xi, yi]),
        "BottomLineC": new makerjs.paths.Line([xi, yi], [xg, yg]),
      }
    };
    
    var myFloorSpring2HCut = {
      paths: {
        "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
        "TopRithgLineC": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
        "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
      }
    };
    var myFloorSpring2HWaterCut0 = {
      paths: {
        "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]),   
        "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
        "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
        "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
        "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
        "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
        "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针          
        "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
      }
    };
    var myFloorSpring2HWaterCut = {
      paths: {
        "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]),   
        "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
        "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
        "TopRithgLineConectC1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
        "RightHolesUpC": new makerjs.paths.Arc([oCX2, oCY2], [oCX3, oCY3], rc, false, false),
        "RightHolesDnC": new makerjs.paths.Arc([oCX3, oCY3],[oCX2, oCY2],  rc, false, false),
        "TopRithgLineConectC2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
        "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针          
        "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
      }
    };
 
    var fillet1 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopRithgLineC1, myFloorSpring2HWaterCut.paths.TopRithgLineConectC1, cutFilletRadius);
    var fillet2 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopRithgLineConectC1, myFloorSpring2HWaterCut.paths.RightHolesUpC, cutFilletRadius);
    var fillet3 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RightHolesDnC, myFloorSpring2HWaterCut.paths.TopRithgLineConectC2, cutFilletRadius);
    var fillet4 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopRithgLineConectC2, myFloorSpring2HWaterCut.paths.TopRithgLineC2, cutFilletRadius);
    var fillet5 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopRithgLineC2, myFloorSpring2HWaterCut.paths.ExitLineC, cutFilletRadius); 
    myFloorSpring2HWaterCut.paths.fillet1 = fillet1;
    myFloorSpring2HWaterCut.paths.fillet2 = fillet2;
    myFloorSpring2HWaterCut.paths.fillet3 = fillet3;
    myFloorSpring2HWaterCut.paths.fillet4 = fillet4;
    myFloorSpring2HWaterCut.paths.fillet5 = fillet5;
  } else if (area == "G") {
    
    var myFloorSpring2H = {
      paths: {
        "LeftLineG": new makerjs.paths.Line([xgwx3, xgwy3], [xa, ya]),
        "TopLeftLineG": new makerjs.paths.Line([xa, ya], [xc, yc]),
        "RithgLineG": new makerjs.paths.Line([xc, yc], [xi, yi]),
        "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),
        "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
        "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
        "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
      }
    };
    var myFloorSpring2HCut = {
      paths: {
        "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
        "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
        "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
      }
    };
    var myFloorSpring2HCutM = {
      paths: {
        "LeftLineG": new makerjs.paths.Line([xgwx3, xgwy3], [xa, ya]),
        "TopLeftLineG": new makerjs.paths.Line([xa, ya], [xc, yc]),
        "RithgLineG": new makerjs.paths.Line([xc, yc], [xi, yi]),
        "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),
        "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
        "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
        "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
        "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
        "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
        "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
      }
    };
    var myFloorSpring2HWaterCut0 = {
      paths: {   
        "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]),                  
        "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
        "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
        "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
        "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
        "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
        "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
        "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
      }
    };
    var myFloorSpring2HWaterCut = {
      paths: {   
        "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]),                  
        "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
        "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
        "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
        "RightHolesDnG": new makerjs.paths.Arc([oGX2, oGY2], [oGX3, oGY3], rg, false, false),
        "RightHolesUpG": new makerjs.paths.Arc([oGX3, oGY3],[oGX2, oGY2],  rg, false, false),
        "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
        "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
        "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
      }
    };
    
    var fillet1 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomLeftLineG1, myFloorSpring2HWaterCut.paths.BottomLeftArcGConect1, cutFilletRadius);
    var fillet2 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomLeftArcGConect1, myFloorSpring2HWaterCut.paths.RightHolesDnG, cutFilletRadius);
    var fillet3 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RightHolesUpG, myFloorSpring2HWaterCut.paths.BottomLeftArcGConect2, cutFilletRadius);
    var fillet4 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomLeftArcGConect2, myFloorSpring2HWaterCut.paths.BottomLeftLineG2, cutFilletRadius);
    var fillet5 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomLeftLineG2, myFloorSpring2HWaterCut.paths.ExitLineG, cutFilletRadius); 
    myFloorSpring2HWaterCut.paths.fillet1 = fillet1;
    myFloorSpring2HWaterCut.paths.fillet2 = fillet2;
    myFloorSpring2HWaterCut.paths.fillet3 = fillet3;
    myFloorSpring2HWaterCut.paths.fillet4 = fillet4;
    myFloorSpring2HWaterCut.paths.fillet5 = fillet5;
 
  } else if (area == "I") {
    
    var myFloorSpring2H = {
      paths: {
        "LeftLineI": new makerjs.paths.Line([xg, yg], [xa, ya]),
        "TopLeftLineI": new makerjs.paths.Line([xa, ya], [xc, yc]),
        "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx3, xiwy3]),
        "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
        "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
        "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
        "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
      }
    };
    var myFloorSpring2HCut = {
      paths: {
        "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
        "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
        "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
      }
    };
    var myFloorSpring2HCutM = {
      paths: {
        "LeftLineI": new makerjs.paths.Line([xg, yg], [xa, ya]),
        "TopLeftLineI": new makerjs.paths.Line([xa, ya], [xc, yc]),
        "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx3, xiwy3]),
        "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
        "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
        "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
        "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
        "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
        "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
        "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
      }
    };
    var myFloorSpring2HWaterCut0 = {
      paths: {
        "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]), 
        "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
        "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
        "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
        "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
        "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
        "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),            
        "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
      }
    };
    var myFloorSpring2HWaterCut = {
      paths: {
        "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]), 
        "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
        "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
        "RightHolesUpI": new makerjs.paths.Arc([oIX2,oIY2],[oIX3,oIY3], ri, false, false),
        "RightHolesDnI": new makerjs.paths.Arc([oIX3,oIY3],[oIX2,oIY2], ri, false, false),
        "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
        "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
        "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),            
        "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
      }
    };
  
    var fillet1 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.EntryLineI, myFloorSpring2HWaterCut.paths.BottomLineI1, cutFilletRadius);
    var fillet2 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomLineI1, myFloorSpring2HWaterCut.paths.RithgLineI1, cutFilletRadius);
    var fillet3 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RithgLineI1, myFloorSpring2HWaterCut.paths.RightHolesUpI, cutFilletRadius);
    var fillet4 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RightHolesDnI, myFloorSpring2HWaterCut.paths.RithgLineI2, cutFilletRadius);
    var fillet5 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RithgLineI2, myFloorSpring2HWaterCut.paths.BottomLineI2, cutFilletRadius); 
    myFloorSpring2HWaterCut.paths.fillet1 = fillet1;
    myFloorSpring2HWaterCut.paths.fillet2 = fillet2;
    myFloorSpring2HWaterCut.paths.fillet3 = fillet3;
    myFloorSpring2HWaterCut.paths.fillet4 = fillet4;
    myFloorSpring2HWaterCut.paths.fillet5 = fillet5;
  } 
  // else if (area == "AC") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx3, xawy3]),
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xi, yi]),
  //       "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xi, yi]),
  //       "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]),  
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),           
  //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
  //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针 
  //       "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
  //     }
  //   };
  //   // var myFillet = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi]]);
  // } else if (area == "AG") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx3, xgwy3], [xawx3, xawy3]),
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
  //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx3, xgwy3], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
  //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]),  
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),           
  //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xi, yi], [xgwx, xgwy]]);
  // } else if (area == "AI") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx3, xawy3]),
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx3, xiwy3]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx3, xiwy3]),
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]),     
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),        
  //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
  //       "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]),  
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),          
  //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xc, yc], [xihx, xihy], [xiwx, xiwy]]);
  // } else if (area == "CG") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xgwx3, xgwy3], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xgwx3, xgwy3], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针  
  //       "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
  //     }
  //   };

  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xi, yi], [xgwx, xgwy]]);
  // } else if (area == "CI") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xiwx3, xiwy3]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xiwx3, xiwy3]),
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]),  
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针 
  //       "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
  //       "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]),     
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),      
  //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
  //     }
  //   };

  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xihx, xihy], [xiwx, xiwy]]);
  // } else if (area == "GI") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineG": new makerjs.paths.Line([xgwx3, xgwy3], [xa, ya]),
  //       "TopLeftLineG": new makerjs.paths.Line([xa, ya], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx3, xiwy3]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineG": new makerjs.paths.Line([xgwx3, xgwy3], [xa, ya]),
  //       "TopLeftLineG": new makerjs.paths.Line([xa, ya], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx3, xiwy3]),
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]),    
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),         
  //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针 
  //       "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
  //     }
  //   };
  //   // var myFillet = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xc, yc], [xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  // } else if (area == "ACG") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx3, xgwy3], [xawx3, xawy3]),
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx3, xgwy3], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]),    
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),           
  //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
  //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]),  
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针 
  //       "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi], [xgwx, xgwy]]);
  // } else if (area == "ACI") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx3, xawy3]),
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "BottomLineI0": new makerjs.paths.Line([xcwx3, xcwy3], [xiwx3, xiwy3]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "BottomLineI0": new makerjs.paths.Line([xcwx3, xcwy3], [xiwx3, xiwy3]),
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xg, xg]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]), 
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),           
  //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
  //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针 
  //       "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
  //       "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]),   
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),          
  //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
  //     }
  //   };

  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy]]);
  // } else if (area == "AGI") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx3, xgwy3], [xawx3, xawy3]),
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx3, xiwy3]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };

  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx3, xgwy3], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx3, xiwy3]),
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),           
  //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
  //       "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]),   
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),           
  //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
  //     }
  //   };

  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  // } else if (area == "CGI") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xgwx3, xgwy3], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xiwx3, xiwy3]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xgwx3, xgwy3], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xiwx3, xiwy3]),
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针  
  //       "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
  //       "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]), 
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),          
  //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
     
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  // } else if (area == "ACGI") {
    
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx3, xgwy3], [xawx3, xawy3]),
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xiwx3, xiwy3]),
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Arc([xawx3, xawy3], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "RithgLineC0": new makerjs.paths.Arc([xcwx2, xcwy2], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "BottomLineI": new makerjs.paths.Arc([xiwx3, xiwy3], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG": new makerjs.paths.Arc([xgwx2, xgwy2], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + h1a, ya - w1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - h1c, yc - w1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + h1g, yg + w1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - h1i, yi + w1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx3, xgwy3], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),
  //       "TopRightLineA": new makerjs.paths.Line([xawx1, xawy1], [xcwx1, xcwy1]),
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx3, xcwy3], [xiwx3, xiwy3]),
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xgwx1, xgwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针
     
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx3-cutLine, xawy3], [xawx3, xawy3]),
  //       "TopLeftLineAArc": new makerjs.paths.Arc([xawx3, xawy3], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftLineAArcTow": new makerjs.paths.Arc([oAX1, oAY1], [xawx2, xawy2], r1a, false, false),//是否大弧,是否顺时针
  //       "TopLeftArcA": new makerjs.paths.Line([xawx2, xawy2], [xawx1, xawy1]),           
  //       "ExitLineA":new makerjs.paths.Line([xawx1, xawy1], [xawx1, xawy1+cutLine]),
  //       "EntryLineC":new makerjs.paths.Line([xcwx1, xcwy1+cutLine], [xcwx1, xcwy1]), 
  //       "TopRightArcC": new makerjs.paths.Line([xcwx1, xcwy1], [xcwx2, xcwy2]),
  //       "TopRithgLineC1": new makerjs.paths.Arc([xcwx2, xcwy2], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2], [oCX3, oCY3]),
  //       "TopRithgLineConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),//是否大弧,是否顺时针
  //       "TopRithgLineC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx3, xcwy3], r1c, false, false),//是否大弧,是否顺时针 
  //       "ExitLineC":new makerjs.paths.Line([xcwx3, xcwy3], [xcwx3+cutLine, xcwy3]),
  //       "EntryLineI":new makerjs.paths.Line([xiwx3+cutLine, xiwy3], [xiwx3, xiwy3]),     
  //       "BottomLineI1": new makerjs.paths.Arc([xiwx3, xiwy3], [oIX1,oIY1], r1i, false, false),//是否大弧,
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomLineI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx2, xiwy2], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomRigthArcI": new makerjs.paths.Line([xiwx2, xiwy2], [xiwx1, xiwy1]),          
  //       "ExitLineI":new makerjs.paths.Line([xiwx1, xiwy1], [xiwx1, xiwy1-cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx1, xgwy1-cutLine], [xgwx1, xgwy1]), 
  //       "BottomLeftArcG": new makerjs.paths.Line([xgwx1, xgwy1], [xgwx2, xgwy2]),
  //       "BottomLeftLineG1": new makerjs.paths.Arc([xgwx2, xgwy2], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针            
  //       "BottomLeftArcGConect1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLeftArcGConect2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftLineG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx3, xgwy3], r1g, false, false),//是否大弧,是否顺时针 
  //       "ExitLineG":new makerjs.paths.Line([xgwx3, xgwy3], [xgwx3-cutLine, xgwy3]),
 
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  // }
}else{
  console.log("短边在X轴￥￥￥￥￥");
  if (area == "A") {
    var myFloorSpring2H = {
      paths: {
        "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
        "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
        "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
        "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xc, yc]),
        "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
        "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
        "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
      }
    };
    var myFloorSpring2HCut = {
      paths: {
        "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
        "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
        "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
      }
    };
    var myFloorSpring2HCutM = {
      paths: {
        "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
        "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
        "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
        "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
        "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
        "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
        "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
        "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xc, yc]),
        "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
        "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
      }
    };
    var myFloorSpring2HWaterCut0 = {
      paths: {
        "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),         
        "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
        "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
        "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
        "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
        "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
        "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针           
        "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
      }
    };
    var myFloorSpring2HWaterCut = {
      paths: {
        "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),         
        "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
        "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
        "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
        "CircleA1": new makerjs.paths.Arc([oAX2, oAY2], [oAX3, oAY3], ra, false, false),//圆
        "CircleA2": new makerjs.paths.Arc([oAX3, oAY3],[oAX2, oAY2],  ra, false, false),//圆
        "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
        "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针           
        "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
      }
    };
  
    var fillet1 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopLeftArcA1, myFloorSpring2HWaterCut.paths.arcAndLineA1, cutFilletRadius);
    var fillet2 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.arcAndLineA1, myFloorSpring2HWaterCut.paths.CircleA1, cutFilletRadius);
    var fillet3 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.CircleA2, myFloorSpring2HWaterCut.paths.arcAndLineA2, cutFilletRadius);
    var fillet4 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.arcAndLineA2, myFloorSpring2HWaterCut.paths.TopLeftArcA2, cutFilletRadius);
    var fillet5 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopLeftArcA2, myFloorSpring2HWaterCut.paths.ExitLineA, cutFilletRadius); 
    myFloorSpring2HWaterCut.paths.fillet1 = fillet1;
    myFloorSpring2HWaterCut.paths.fillet2 = fillet2;
    myFloorSpring2HWaterCut.paths.fillet3 = fillet3;
    myFloorSpring2HWaterCut.paths.fillet4 = fillet4;
    myFloorSpring2HWaterCut.paths.fillet5 = fillet5;
  } else if (area == "C") {
    var myFloorSpring2H = {
      paths: {
        "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
        "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx3, xcwy3]),
        "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
        "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
        "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
        "BottomLineC": new makerjs.paths.Line([xi, yi], [xg, yg]),
        "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
      }
    };
    var myFloorSpring2HCut = {
      paths: {
        "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
        "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
        "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
      }
    };
    var myFloorSpring2HCutM = {
      paths: {
        "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
        "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx3, xcwy3]),
        "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
        "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
        "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
        "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
        "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
        "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
        "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
        "BottomLineC": new makerjs.paths.Line([xi, yi], [xg, yg]),
      }
    };
    var myFloorSpring2HWaterCut0 = {
      paths: {
        "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]),  
        "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
        "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
        "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
        "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
        "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
        "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]), 
        "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),
      }
    };
    var myFloorSpring2HWaterCut = {
      paths: {
        "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]),  
        "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
        "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
        "RightHolesC1": new makerjs.paths.Arc([oCX2, oCY2],[oCX3, oCY3], rc, false, false),
        "RightHolesC2": new makerjs.paths.Arc([oCX3, oCY3],[oCX2, oCY2], rc, false, false),
        "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
        "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
        "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]), 
        "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),
      }
    };
    var fillet1 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.EntryLineC, myFloorSpring2HWaterCut.paths.TopRightArcC1, cutFilletRadius);
    var fillet2 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopRightArcC1, myFloorSpring2HWaterCut.paths.TopLeftLineCConect1, cutFilletRadius);
    var fillet3 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopLeftLineCConect1, myFloorSpring2HWaterCut.paths.RightHolesC1, cutFilletRadius);
    var fillet4 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RightHolesC2, myFloorSpring2HWaterCut.paths.TopLeftLineCConect2, cutFilletRadius);
    var fillet5 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.TopLeftLineCConect2, myFloorSpring2HWaterCut.paths.TopRightArcC2, cutFilletRadius); 
    myFloorSpring2HWaterCut.paths.fillet1 = fillet1;
    myFloorSpring2HWaterCut.paths.fillet2 = fillet2;
    myFloorSpring2HWaterCut.paths.fillet3 = fillet3;
    myFloorSpring2HWaterCut.paths.fillet4 = fillet4;
    myFloorSpring2HWaterCut.paths.fillet5 = fillet5;
    // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xi, yi]]);
  } else if (area == "G") {
    var myFloorSpring2H = {
      paths: {
        "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
        "TopLeftLineG": new makerjs.paths.Line([xa, ya], [xc, yc]),
        "RithgLineG": new makerjs.paths.Line([xc, yc], [xi, yi]),
        "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx3, xgwy3]),
        "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
        "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
        "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
      }
    };
    var myFloorSpring2HCut = {
      paths: {
        "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
        "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
        "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
      }
    };
    var myFloorSpring2HCutM = {
      paths: {
        "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
        "TopLeftLineG": new makerjs.paths.Line([xa, ya], [xc, yc]),
        "RithgLineG": new makerjs.paths.Line([xc, yc], [xi, yi]),
        "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx3, xgwy3]),
        "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
        "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
        "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
        "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
        "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
        "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
      }
    };
    var myFloorSpring2HWaterCut0 = {
      paths: {
        "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]), 
        "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
        "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
        "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
        "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
        "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
        "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
        "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
      }
    };
    var myFloorSpring2HWaterCut = {
      paths: {
        "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]), 
        "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
        "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
        "RightHolesG1": new makerjs.paths.Arc([oGX2, oGY2], [oGX3, oGY3], rg, false, false),
        "RightHolesG2": new makerjs.paths.Arc([oGX3, oGY3],[oGX2, oGY2],  rg, false, false),
        "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
        "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
        "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
        "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
      }
    };
    var fillet1 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.EntryLineG, myFloorSpring2HWaterCut.paths.BottomLeftArcG1, cutFilletRadius);
    var fillet2 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomLeftArcG1, myFloorSpring2HWaterCut.paths.BottomLineGCn1, cutFilletRadius);
    var fillet3 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomLineGCn1, myFloorSpring2HWaterCut.paths.RightHolesG1, cutFilletRadius);
    var fillet4 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RightHolesG2, myFloorSpring2HWaterCut.paths.BottomLineGCn2, cutFilletRadius);
    var fillet5 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomLineGCn2, myFloorSpring2HWaterCut.paths.BottomLeftArcG2, cutFilletRadius); 
    myFloorSpring2HWaterCut.paths.fillet1 = fillet1;
    myFloorSpring2HWaterCut.paths.fillet2 = fillet2;
    myFloorSpring2HWaterCut.paths.fillet3 = fillet3;
    myFloorSpring2HWaterCut.paths.fillet4 = fillet4;
    myFloorSpring2HWaterCut.paths.fillet5 = fillet5;
  } else if (area == "I") {
    var myFloorSpring2H = {
      paths: {
        "LeftLineI": new makerjs.paths.Line([xg, yg], [xa, ya]),
        "TopLeftLineI": new makerjs.paths.Line([xa, ya], [xc, yc]),
        "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
        "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
        "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
        "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xg, xg]),
        "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
      }
    };
    var myFloorSpring2HCut = {
      paths: {
        "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
        "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
        "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
      }
    };
    var myFloorSpring2HCutM = {
      paths: {
        "LeftLineI": new makerjs.paths.Line([xg, yg], [xa, ya]),
        "TopLeftLineI": new makerjs.paths.Line([xa, ya], [xc, yc]),
        "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
        "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
        "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
        "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
        "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
        "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
        "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
        "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xg, xg]),
      }
    };
    var myFloorSpring2HWaterCut0 = {
      paths: {
        "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
        "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
        "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
        "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
        "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
        "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
        "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针           
        "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
      }
    };
    var myFloorSpring2HWaterCut = {
      paths: {
        "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
        "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
        "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
        "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
        "RightHolesI1": new makerjs.paths.Arc([oIX2,oIY2],[oIX3,oIY3], ri, false, false),
        "RightHolesI2": new makerjs.paths.Arc([oIX3,oIY3], [oIX2,oIY2],ri, false, false),
        "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
        "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针           
        "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
      }
    };
    var fillet1 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomRigthArcI1, myFloorSpring2HWaterCut.paths.RithgLineI1, cutFilletRadius);
    var fillet2 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RithgLineI1, myFloorSpring2HWaterCut.paths.RightHolesI1, cutFilletRadius);
    var fillet3 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RightHolesI2, myFloorSpring2HWaterCut.paths.RithgLineI2, cutFilletRadius);
    var fillet4 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.RithgLineI2, myFloorSpring2HWaterCut.paths.BottomRigthArcI2, cutFilletRadius);
    var fillet5 = makerjs.path.fillet(myFloorSpring2HWaterCut.paths.BottomRigthArcI2, myFloorSpring2HWaterCut.paths.ExitLineI, cutFilletRadius); 
    myFloorSpring2HWaterCut.paths.fillet1 = fillet1;
    myFloorSpring2HWaterCut.paths.fillet2 = fillet2;
    myFloorSpring2HWaterCut.paths.fillet3 = fillet3;
    myFloorSpring2HWaterCut.paths.fillet4 = fillet4;
    myFloorSpring2HWaterCut.paths.fillet5 = fillet5;
  } 
  // else if (area == "AC") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xcwx3, xcwy3]),
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
  //       "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
  //       "BottomLineA": new makerjs.paths.Line([xi, yi], [xg, yg]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),   
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针          
  //       "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
  //       "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]), 
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "TopRithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),
  //     }
  //   };
  //   // var myFillet = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi]]);
  // } else if (area == "AG") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xc, yc]),
  //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx3, xgwy3]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xc, yc]),
  //       "RithgLineA": new makerjs.paths.Line([xc, yc], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针         
  //       "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xi, yi], [xgwx, xgwy]]);
  // } else if (area == "AI") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xg, xg]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xg, xg]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针          
  //       "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
  //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),   
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针        
  //       "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xc, yc], [xihx, xihy], [xiwx, xiwy]]);
  // } else if (area == "CG") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx3, xcwy3]),
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx3, xgwy3]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]), 
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]), 
  //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]), 
  //       "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]), 
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
  //     }
  //   };

  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xi, yi], [xgwx, xgwy]]);
  // } else if (area == "CI") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx3, xcwy3]),
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xg, xg]),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xg, yg], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xg, xg]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]), 
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
  //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针          
  //       "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
  //     }
  //   };

  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xa, ya], [xcwx, xcwy], [xchx, xchy], [xihx, xihy], [xiwx, xiwy]]);
  // } else if (area == "GI") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
  //       "TopLeftLineG": new makerjs.paths.Line([xa, ya], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xgwx3, xgwy3]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineG": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
  //       "TopLeftLineG": new makerjs.paths.Line([xa, ya], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),  
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针         
  //       "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
  //     }
  //   };
  //   // var myFillet = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xc, yc], [xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  // } else if (area == "ACG") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xcwx3, xcwy3]),
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx3, xgwy3]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xi, yi]),
  //       "BottomLineG": new makerjs.paths.Line([xi, yi], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),   
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针       
  //       "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
  //       "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]), 
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
  //       "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]), 
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xi, yi], [xgwx, xgwy]]);
  // } else if (area == "ACI") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xcwx3, xcwy3]),
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "BottomLineI0": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xg, xg]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xg, yg], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "BottomLineI0": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xg, xg]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针          
  //       "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
  //       "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
  //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),   
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针       
  //       "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
  //     }
  //   };

  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xg, yg], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy]]);
  // } else if (area == "AGI") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xgwx3, xgwy3]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xc, yc]),
  //       "RithgLineI": new makerjs.paths.Line([xc, yc], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]), 
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针          
  //       "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
  //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),  
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针        
  //       "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]), 
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
  //     }
  //   };

  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xc, yc],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  // } else if (area == "CGI") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx3, xcwy3]),
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xgwx3, xgwy3]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "RightLineC": new makerjs.paths.Line([xgwx1, xgwy1], [xa, ya]),
  //       "TopLeftLineC": new makerjs.paths.Line([xa, ya], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]), 
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
  //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]),     
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针       
  //       "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]), 
  //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xa, ya], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  // } else if (area == "ACGI") {
  //   var myFloorSpring2H = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xcwx3, xcwy3]),
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xgwx3, xgwy3]),
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCut = {
  //     paths: {
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA": new makerjs.paths.Arc([xawx2, xawy2], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightArcC": new makerjs.paths.Arc([xcwx3, xcwy3], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI": new makerjs.paths.Arc([xiwx2, xiwy2], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftArcG": new makerjs.paths.Arc([xgwx3, xgwy3], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "RightHolesA": new makerjs.paths.Circle([xa + w1a, ya - h1a], ra),
  //       "RightHolesC": new makerjs.paths.Circle([xc - w1c, yc - h1c], rc),
  //       "RightHolesG": new makerjs.paths.Circle([xg + w1g, yg + h1g], rg),
  //       "RightHolesI": new makerjs.paths.Circle([xi - w1i, yi + h1i], ri),
  //     }
  //   };
  //   var myFloorSpring2HCutM = {
  //     paths: {
  //       "LeftLineA": new makerjs.paths.Line([xgwx1, xgwy1], [xawx1, xawy1]),
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针
  //       "TopRightLineA": new makerjs.paths.Line([xawx3, xawy3], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "RithgLineC": new makerjs.paths.Line([xcwx1, xcwy1], [xiwx1, xiwy1]),
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineI": new makerjs.paths.Line([xiwx3, xiwy3], [xgwx3, xgwy3]),
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //     }
  //   };
  //   var myFloorSpring2HWaterCut = {
  //     paths: {
  //       "EntryLineA":new makerjs.paths.Line([xawx1-cutLine, xawy1], [xawx1, xawy1]), 
  //       "TopLeftLineA": new makerjs.paths.Line([xawx1, xawy1], [xawx2, xawy2]),
  //       "TopLeftArcA1": new makerjs.paths.Arc([xawx2, xawy2], [oAX1, oAY1], r1a, false, false),//是否大弧,是否顺时针
  //       "arcAndLineA1":new makerjs.paths.Line([oAX1, oAY1], [oAX2, oAY2]),
  //       "Circle": new makerjs.paths.Circle([oAX2, oAY2], [oAX3, oAY3]),//圆
  //       "arcAndLineA2":new makerjs.paths.Line([oAX2, oAY2], [oAX1, oAY1]),
  //       "TopLeftArcA2": new makerjs.paths.Arc([oAX1, oAY1], [xawx3, xawy3], r1a, false, false),//是否大弧,是否顺时针         
  //       "ExitLineA":new makerjs.paths.Line([xawx3, xawy3], [xawx3, xawy3+cutLine]),
  //       "EntryLineC":new makerjs.paths.Line([xcwx3, xcwy3+cutLine], [xcwx3, xcwy3]),
  //       "TopRightArcC1": new makerjs.paths.Arc([xcwx3, xcwy3], [oCX1, oCY1], r1c, false, false),//是否大弧,是否顺时针
  //       "TopLeftLineCConect1": new makerjs.paths.Line([oCX1, oCY1], [oCX2, oCY2]),
  //       "RightHolesC": new makerjs.paths.Circle([oCX2, oCY2],[oCX3, oCY3]),
  //       "TopLeftLineCConect2": new makerjs.paths.Line([oCX2, oCY2], [oCX1, oCY1]),
  //       "TopRightArcC2": new makerjs.paths.Arc([oCX1, oCY1], [xcwx2, xcwy2], r1c, false, false),//是否大弧,是否顺时针
  //       "RithgLineC0": new makerjs.paths.Line([xcwx2, xcwy2], [xcwx1, xcwy1]),
  //       "ExitLineC":new makerjs.paths.Line([xcwx1, xcwy1], [xcwx1+cutLine, xcwy1]),  
  //       "EntryLineI":new makerjs.paths.Line([xiwx1+cutLine, xiwy1], [xiwx1, xiwy1]), 
  //       "BottomLineI": new makerjs.paths.Line([xiwx1, xiwy1], [xiwx2, xiwy2]),
  //       "BottomRigthArcI1": new makerjs.paths.Arc([xiwx2, xiwy2], [oIX1,oIY1], r1i, false, false),//是否大弧,是否顺时针
  //       "RithgLineI1": new makerjs.paths.Line([oIX1,oIY1], [oIX2,oIY2]),
  //       "RightHolesI": new makerjs.paths.Circle([oIX2,oIY2],[oIX3,oIY3]),
  //       "RithgLineI2": new makerjs.paths.Line([oIX2,oIY2],[oIX1,oIY1]),
  //       "BottomRigthArcI2": new makerjs.paths.Arc([oIX1,oIY1], [xiwx3, xiwy3], r1i, false, false),//是否大弧,是否顺时针         
  //       "ExitLineI":new makerjs.paths.Line([xiwx3, xiwy3], [xiwx3, xiwy3-cutLine]),
  //       "EntryLineG":new makerjs.paths.Line([xgwx3, xgwy3-cutLine], [xgwx3, xgwy3]), 
  //       "BottomLeftArcG1": new makerjs.paths.Arc([xgwx3, xgwy3], [oGX1, oGY1], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLineGCn1": new makerjs.paths.Line([oGX1, oGY1], [oGX2, oGY2]),
  //       "RightHolesG": new makerjs.paths.Circle([oGX2, oGY2], [oGX3, oGY3]),
  //       "BottomLineGCn2": new makerjs.paths.Line([oGX2, oGY2], [oGX1, oGY1]),
  //       "BottomLeftArcG2": new makerjs.paths.Arc([oGX1, oGY1], [xgwx2, xgwy2], r1g, false, false),//是否大弧,是否顺时针
  //       "BottomLeftLineG": new makerjs.paths.Line([xgwx2, xgwy2], [xgwx1, xgwy1]),
  //       "ExitLineG":new makerjs.paths.Line([xgwx1, xgwy1], [xgwx1-cutLine, xgwy1]),
  //     }
  //   };
  //   // var myCorner = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
  // }
}

  return [myFloorSpring2H,myFloorSpring2HCut,myFloorSpring2HCutM,myFloorSpring2HWaterCut];
};
// 矩形等去角标记 连线函数
function creatFloorSpring2HMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
  console.log("是否调用此函数creatFloorSpring2HMark()");
  console.log("是否调用此函数param", param);
  console.log("是否调用此函数outParam", outParam);
  console.log("是否调用此函数inputParam", inputParam);
  console.log("是否调用此函数OffsetParam", OffsetParam);
  var HH = outParam.H, WW = outParam.W, D = inputParam.D, H = inputParam.H, H1 = inputParam.H1, W = inputParam.W, W1 = inputParam.W1, W2 = inputParam.W2, W2 = inputParam.W2, R = inputParam.R, R1 = inputParam.R1, R2 = inputParam.R2,
    markShiftTwo = fixedParam.markShiftTwo * 1, myZoom = zoom * 1,
    // // rd = OffsetParam.rMark * 1,
    //   Aa=OffsetParam.Aa*1,Aaa=OffsetParam.Aaa*1,Ab=OffsetParam.Ab*1,Ahd=OffsetParam.Ahd*1,
    //   Ca=OffsetParam.a*1,Caa=OffsetParam.Caa*1,Cb=OffsetParam.Cb*1,Chd=OffsetParam.Chd*1,
    //   Ga=OffsetParam.Ga*1,Gaa=OffsetParam.Gaa*1,Gb=OffsetParam.Gb*1,Ghd=OffsetParam.Ghd*1,
    //   Ia=OffsetParam.Ia*1,Iaa=OffsetParam.Iaa*1,Ib=OffsetParam.Ib*1,Ihd=OffsetParam.Ihd*1,
    //   ihd=OffsetParam.ihd*1,iwd=OffsetParam.iwd*1,iwdd=OffsetParam.iwdd*1,
    xa = param.xa, ya = param.ya, xawx1 = param.xawx1, xawy1 = param.xawy1, xawx2 = param.xawx2, xawy2 = param.xawy2, xawx3 = param.xawx3, xawy3 = param.xawy3,
    xc = param.xc, yc = param.yc, xcwx1 = param.xcwx1, xcwy1 = param.xcwy1, xcwx2 = param.xcwx2, xcwy2 = param.xcwy2, xcwx3 = param.xcwx3, xcwy3 = param.xcwy3,
    xg = param.xg, yg = param.yg, xgwx1 = param.xgwx1, xgwy1 = param.xgwy1, xgwx2 = param.xgwx2, xgwy2 = param.xgwy2, xgwx3 = param.xgwx3, xgwy3 = param.xgwy3,
    xi = param.xi, yi = param.yi, xiwx1 = param.xiwx1, xiwy1 = param.xiwy1, xiwx2 = param.xiwx2, xiwy2 = param.xiwy2, xiwx3 = param.xiwx3, xiwy3 = param.xiwy3,
    r = param.r, r1 = param.r1, r2 = param.r2, w = param.w, w1 = param.w1, w2 = param.w2, h = param.h, h1 = param.h1,
    da = param.da,ra = param.ra,r1a = param.r1a,wa = param.wa,w1a = param.w1a,w2a = param.w2a,ha = param.ha,h1a = param.h1a,
    dc = param.dc,rc = param.rc,r1c = param.r1c,wc = param.wc,w1c = param.w1c,w2c = param.w2c,hc = param.hc,h1c = param.h1c,
    dg = param.dg,rg = param.rg,r1g = param.r1g,wg = param.wg,w1g = param.w1g,w2g = param.w2g,hg = param.hg,h1g = param.h1g,
    di = param.di,ri = param.ri,r1i = param.r1i,wi= param.wi,w1i = param.w1i,w2i = param.w2i,hi = param.hi,h1i = param.h1i,   
    markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
    markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

    glassH=param.glassH,glassW=param.glassW,
    w = W * 1 * myZoom,
    w1 = W1 * 1 * myZoom,
    w2 = W2 * 1 * myZoom,
    h = H * 1 * myZoom,
    h1 = H1 * 1 * myZoom,
    r1 = R * 1 * myZoom,
    d = D * 1 * myZoom,
    r = d / 2,
    a = 0,//圆心坐标[a,b]
    b = 0;//圆心坐标[a,b]  
  // x0 = X*1*myZoom,
  //y0 = Y*1*myZoom;   


  if (d !== 0) {
    var TxtD = "∮" + D;
  }
  if (r1 !== 0) {
    var TxtR1 = "R=" + R;
  }
  if (w !== 0) {
    var TxtW = W;
  }
  if (w1 !== 0) {
    var TxtW1 = W1;
  }
  if (w2 !== 0) {
    var TxtW2 = W2;
  }
  if (h !== 0) {
    var TxtH = H;
  }
  if (h1 !== 0) {
    var TxtH1 = H1;
  }
  ///////////////////////////
  if (da !== 0) {
    var TxtDa = "∮" + da.toString();
  }
  if (r1a !== 0) {
    var TxtR1a = "R=" + r1a.toString();
  }
  if (wa !== 0) {
    var TxtWa = wa.toString();
  }
  if (w1a !== 0) {
    var TxtW1a = w1a.toString();
  }
  if (w2a !== 0) {
    var TxtW2a = w2a.toString();
  }
  if (ha !== 0) {
    var TxtHa = ha.toString();
  }
  if (h1a !== 0) {
    var TxtH1a = h1a.toString();
  }
  //////////////////////////
  if (dc !== 0) {
    var TxtDc = "∮" + dc.toString();
  }
  if (r1c !== 0) {
    var TxtR1c = "R=" + r1c.toString();
  }
  if (wc !== 0) {
    var TxtWc = wc.toString();
  }
  if (w1c !== 0) {
    var TxtW1c = w1c.toString();
  }
  if (w2c !== 0) {
    var TxtW2c = w2c.toString();
  }
  if (hc !== 0) {
    var TxtHc = hc.toString();
  }
  if (h1c !== 0) {
    var TxtH1c = h1c.toString();
  }
  /////////////////////
  if (dg !== 0) {
    var TxtDg = "∮" + dg.toString();
  }
  if (r1g !== 0) {
    var TxtR1g = "R=" + r1g.toString();
  }
  if (wg !== 0) {
    var TxtWg = wg.toString();
  }
  if (w1g !== 0) {
    var TxtW1g = w1g.toString();
  }
  if (w2g !== 0) {
    var TxtW2g = w2g.toString();
  }
  if (hg !== 0) {
    var TxtHg = hg.toString();
  }
  if (h1g !== 0) {
    var TxtH1g = h1g.toString();
  }
  /////////////////////////
  if (di !== 0) {
    var TxtDi = "∮" + di.toString();
  }
  if (r1i !== 0) {
    var TxtR1i = "R=" + r1i.toString();
  }
  if (wi !== 0) {
    var TxtWi = wi.toString();
  }
  if (w1i !== 0) {
    var TxtW1i = w1i.toString();
  }
  if (w2i !== 0) {
    var TxtW2i = w2i.toString();
  }
  if (hi !== 0) {
    var TxtHi = hi.toString();
  }
  if (h1i !== 0) {
    var TxtH1i = h1i.toString();
  }


  console.log("console.log TxtDg,TxtR1g,TxtR2g,TxtWg,TxtHg,TxtH1g,TxtDg",TxtDg,TxtR1g,TxtWg,TxtHg,TxtH1g,TxtDg)
  console.log("console.log TxtRg,TxtR1g,TxtR2g,TxtWg,TxtHg,TxtH1g,TxtDg",rg,r1g,wg,hg,h1g,dg)
  
console.log("glassH,glassW",glassH,glassW);
  if(glassW*1<glassH * 1){
    console.log("creatFloorSpring2HMark=长边在X轴￥￥￥￥￥");
    if (area == "A") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + ha, ya - wa], [xa + ha + markShiftThree, ya - wa]),//左上角
          "WALine1": new makerjs.paths.Line([xa+ha + markShift, ya], [xa + ha + markShift, ya - wa]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa+ha + da + markShift, ya], [xa + ha + da + markShift, ya - w1a]),
          "W1ALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftThree, ya - w1a]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa, ya-w2a], [xa + ra + h1a + h1a + markShiftFour, ya - w2a]),
          "W2ALine1": new makerjs.paths.Line([xa + ha + ha + markShiftThree, ya], [xa +  ha + ha + markShiftThree, ya - w2a]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa, ya+ markShiftFour]),
          "HALine1": new makerjs.paths.Line([xa+ ha, ya ], [xa + ha, ya + markShiftFour]),//左上角
          "HALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa + ha, ya + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa+h1a, ya -  w1a + ra], [xa +h1a , ya - w2a - ra - markShiftFour]),
          "H1ALine1": new makerjs.paths.Line([xa, ya- w2a - markShift], [xa + h1a , ya - w2a- markShift]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa +ha , ya - wa - (wa / 2)], [xa + ha - markShiftTwo, ya - wa - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD]),//左上角
        }
      };
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa + ha + markShiftThree, ya - wa], [xa + ha + markShiftThree, ya]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa + ha  + da+ markShiftThree, ya - w1a], [xa + ha + da + markShiftThree, ya]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa + ha + ha + da + markShiftThree, ya - w2a], [xa + ha + ha + da + markShiftThree, ya]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa, ya + markShiftFour], [xa + ha, ya + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa, ya - w2a - markShiftThree], [xa + h1a, ya - w2a - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + ha - markShiftTwo, ya - wa - markShiftFour], [xa + ha, ya - wa - (wa / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markHolesOneD - markShiftFour]);//D文字标注  
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
      }
  
    } else if (area == "C") {
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc - hc, yc], [xc - hc - markShiftThree, yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - hc, yc - wc], [xc - hc - markShiftThree, yc - wc]),//左上角
          "WCLine2": new makerjs.paths.Line([xc - hc - markShift, yc], [xc - hc - markShift, yc - wc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc - hc - dc - markShift, yc], [xc - hc - dc - markShift, yc - w1c]),
          "W1CLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftThree, yc - w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc - hc - hc - markShiftThree, yc], [xc - hc - hc - markShiftThree, yc - w2c]),
          "W2CLine1": new makerjs.paths.Line([xc, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc - w2c]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
          "HCLine1": new makerjs.paths.Line([xc - hc, yc], [xc - hc, yc + markShiftFour]),//左上角
          "HCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - hc, yc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c, yc - w1c - dc / 2 - markShiftFour]),
          "H1CLine1": new makerjs.paths.Line([xc, yc - w2c - markShift], [xc - h1c, yc - w2c - markShift]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]),//左上角
        }
      };
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - hc - markShiftThree, yc - wc], [xc - hc - markShiftThree, yc]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - hc - dc - markShiftThree, yc - w1c], [xc - hc - dc - markShiftThree, yc]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - hc - hc - dc - markShiftFour, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc - hc, yc + markShiftFour], [xc, yc + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - h1c, yc - w2c - markShiftThree], [xc, yc - w2c - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markHolesOneD - markShiftFour], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]);//D文字标注  
     
      ////////////****************************** */
      var markers = {
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
      }
    } else if (area == "G") {
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg + hg, yg], [xg + hg + markShiftThree, yg]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + hg, yg + wg], [xg + hg + markShiftThree, yg + wg]),//左上角
          "WGLine2": new makerjs.paths.Line([xg + hg + markShift, yg], [xg + hg + markShift, yg + wg]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg + hg + dg + markShift, yg], [xg + hg + dg + markShift, yg + w1g]),
          "W1GLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftThree, yg + w1g]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg + hg + hg + markShiftThree, yg], [xg + hg + hg + markShiftThree, yg + w2g]),
          "W2GLine1": new makerjs.paths.Line([xg, yg + w2g], [xg + hg + hg + dg + markShiftFour, yg + w2g]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
          "HGLine1": new makerjs.paths.Line([xg + hg, yg], [xg + hg, yg - markShiftFour]),//左上角
          "HGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + hg, yg - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g, yg + w1g + dg / 2 + markShiftFour]),
          "H1GLine1": new makerjs.paths.Line([xg, yg + w2g + markShift], [xg + h1g, yg + w2g + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + hg, yg + wg + (wg / 2)], [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD]),//左上角
        }
      };
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg + hg + markShiftThree, yg], [xg + hg + markShiftThree, yg + wg]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg + hg + dg + markShiftThree, yg], [xg + hg + dg + markShiftThree, yg + w1g]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg + hg + hg + dg + markShiftFour, yg], [xg + hg + hg + dg + markShiftFour, yg + w2g]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg, yg - markShiftFour], [xg + hg, yg - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg, yg + w2g + markShiftThree], [xg + h1g, yg + w2g + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour], [xg + hg, yg + wg + (wg / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markHolesOneD + markShiftFour]);//D文字标注  
    
    /////////////////////******************************************** */
      var markers = {
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
      }
  
    } else if (area == "I") {
   
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi - hi, yi], [xi - hi - markShiftThree, yi]),//左上角
          "WILine1": new makerjs.paths.Line([xi - hi, yi + wi], [xi - hi - markShiftThree, yi + wi]),//左上角
          "WILine2": new makerjs.paths.Line([xi - hi - markShift, yi], [xi - hi - markShift, yi + wi]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi - hi - di - markShift, yi], [xi - hi - di - markShift, yi + w1i]),
          "W1ILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftThree, yi + w1i]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi - hi - hi - markShiftThree, yi], [xi - hi - hi - markShiftThree, yi + w2i]),
          "W2ILine1": new makerjs.paths.Line([xi, yi + w2i], [xi - hi - hi - di - markShiftFour, yi + w2i]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
          "HILine1": new makerjs.paths.Line([xi - hi, yi], [xi - hi, yi - markShiftFour]),//左上角
          "HILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - hi, yi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i, yi + w1i + di / 2 + markShiftFour]),
          "H1ILine1": new makerjs.paths.Line([xi, yi + w2i + markShift], [xi - h1i, yi + w2i + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
     
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - hi - markShiftThree, yi + wi], [xi - hi - markShiftThree, yi]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - hi - di - markShiftThree, yi + w1i], [xi - hi - di - markShiftThree, yi]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - hi - hi - di - markShiftFour, yi + w2i], [xi - hi - hi - di - markShiftFour, yi]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi - hi, yi - markShiftFour], [xi, yi - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - h1i, yi + w2i + markShiftThree], [xi, yi + w2i + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markHolesOneD + markShiftFour], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]);//D文字标注  
 
      /************************************************************************************** */
      var markers = {
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  
    } else if (area == "AC") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + ha, ya - wa], [xa + ha + markShiftThree, ya - wa]),//左上角
          "WALine1": new makerjs.paths.Line([xa+ha + markShift, ya], [xa + ha + markShift, ya - wa]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa+ha + da + markShift, ya], [xa + ha + da + markShift, ya - w1a]),
          "W1ALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftThree, ya - w1a]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa, ya-w2a], [xa + ra + h1a + h1a + markShiftFour, ya - w2a]),
          "W2ALine1": new makerjs.paths.Line([xa + ha + ha + markShiftThree, ya], [xa +  ha + ha + markShiftThree, ya - w2a]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa, ya+ markShiftFour]),
          "HALine1": new makerjs.paths.Line([xa+ ha, ya ], [xa + ha, ya + markShiftFour]),//左上角
          "HALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa + ha, ya + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa+h1a, ya -  w1a + ra], [xa +h1a , ya - w2a - ra - markShiftFour]),
          "H1ALine1": new makerjs.paths.Line([xa, ya- w2a - markShift], [xa + h1a , ya - w2a- markShift]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa +ha , ya - wa - (wa / 2)], [xa + ha - markShiftTwo, ya - wa - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD]),//左上角
        }
      };
     
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc - hc, yc], [xc - hc - markShiftThree, yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - hc, yc - wc], [xc - hc - markShiftThree, yc - wc]),//左上角
          "WCLine2": new makerjs.paths.Line([xc - hc - markShift, yc], [xc - hc - markShift, yc - wc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc - hc - dc - markShift, yc], [xc - hc - dc - markShift, yc - w1c]),
          "W1CLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftThree, yc - w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc - hc - hc - markShiftThree, yc], [xc - hc - hc - markShiftThree, yc - w2c]),
          "W2CLine1": new makerjs.paths.Line([xc, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc - w2c]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
          "HCLine1": new makerjs.paths.Line([xc - hc, yc], [xc - hc, yc + markShiftFour]),//左上角
          "HCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - hc, yc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c, yc - w1c - dc / 2 - markShiftFour]),
          "H1CLine1": new makerjs.paths.Line([xc, yc - w2c - markShift], [xc - h1c, yc - w2c - markShift]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]),//左上角
        }
      };
  
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa + ha + markShiftThree, ya - wa], [xa + ha + markShiftThree, ya]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa + ha  + da+ markShiftThree, ya - w1a], [xa + ha + da + markShiftThree, ya]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa + ha + ha + da + markShiftThree, ya - w2a], [xa + ha + ha + da + markShiftThree, ya]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa, ya + markShiftFour], [xa + ha, ya + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa, ya - w2a - markShiftThree], [xa + h1a, ya - w2a - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + ha - markShiftTwo, ya - wa - markShiftFour], [xa + ha, ya - wa - (wa / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markHolesOneD - markShiftFour]);//D文字标注  
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - hc - markShiftThree, yc - wc], [xc - hc - markShiftThree, yc]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - hc - dc - markShiftThree, yc - w1c], [xc - hc - dc - markShiftThree, yc]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - hc - hc - dc - markShiftFour, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc - hc, yc + markShiftFour], [xc, yc + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - h1c, yc - w2c - markShiftThree], [xc, yc - w2c - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markHolesOneD - markShiftFour], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]);//D文字标注
     
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        /**I */
  
      }
  
    } else if (area == "AG") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + ha, ya - wa], [xa + ha + markShiftThree, ya - wa]),//左上角
          "WALine1": new makerjs.paths.Line([xa+ha + markShift, ya], [xa + ha + markShift, ya - wa]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa+ha + da + markShift, ya], [xa + ha + da + markShift, ya - w1a]),
          "W1ALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftThree, ya - w1a]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa, ya-w2a], [xa + ra + h1a + h1a + markShiftFour, ya - w2a]),
          "W2ALine1": new makerjs.paths.Line([xa + ha + ha + markShiftThree, ya], [xa +  ha + ha + markShiftThree, ya - w2a]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa, ya+ markShiftFour]),
          "HALine1": new makerjs.paths.Line([xa+ ha, ya ], [xa + ha, ya + markShiftFour]),//左上角
          "HALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa + ha, ya + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa+h1a, ya -  w1a + ra], [xa +h1a , ya - w2a - ra - markShiftFour]),
          "H1ALine1": new makerjs.paths.Line([xa, ya- w2a - markShift], [xa + h1a , ya - w2a- markShift]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa +ha , ya - wa - (wa / 2)], [xa + ha - markShiftTwo, ya - wa - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD]),//左上角
        }
      };
  
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg + hg, yg], [xg + hg + markShiftThree, yg]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + hg, yg + wg], [xg + hg + markShiftThree, yg + wg]),//左上角
          "WGLine2": new makerjs.paths.Line([xg + hg + markShift, yg], [xg + hg + markShift, yg + wg]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg + hg + dg + markShift, yg], [xg + hg + dg + markShift, yg + w1g]),
          "W1GLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftThree, yg + w1g]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg + hg + hg + markShiftThree, yg], [xg + hg + hg + markShiftThree, yg + w2g]),
          "W2GLine1": new makerjs.paths.Line([xg, yg + w2g], [xg + hg + hg + dg + markShiftFour, yg + w2g]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
          "HGLine1": new makerjs.paths.Line([xg + hg, yg], [xg + hg, yg - markShiftFour]),//左上角
          "HGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + hg, yg - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g, yg + w1g + dg / 2 + markShiftFour]),
          "H1GLine1": new makerjs.paths.Line([xg, yg + w2g + markShift], [xg + h1g, yg + w2g + markShift]),//左上角
        }
      };  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + hg, yg + wg + (wg / 2)], [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD]),//左上角
        }
      };
     
     
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa + ha + markShiftThree, ya - wa], [xa + ha + markShiftThree, ya]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa + ha  + da+ markShiftThree, ya - w1a], [xa + ha + da + markShiftThree, ya]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa + ha + ha + da + markShiftThree, ya - w2a], [xa + ha + ha + da + markShiftThree, ya]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa, ya + markShiftFour], [xa + ha, ya + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa, ya - w2a - markShiftThree], [xa + h1a, ya - w2a - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + ha - markShiftTwo, ya - wa - markShiftFour], [xa + ha, ya - wa - (wa / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markHolesOneD - markShiftFour]);//D文字标注  
     /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg + hg + markShiftThree, yg], [xg + hg + markShiftThree, yg + wg]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg + hg + dg + markShiftThree, yg], [xg + hg + dg + markShiftThree, yg + w1g]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg + hg + hg + dg + markShiftFour, yg], [xg + hg + hg + dg + markShiftFour, yg + w2g]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg, yg - markShiftFour], [xg + hg, yg - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg, yg + w2g + markShiftThree], [xg + h1g, yg + w2g + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour], [xg + hg, yg + wg + (wg / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markHolesOneD + markShiftFour]);//D文字标注  
    /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
  
      }
    } else if (area == "AI") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + ha, ya - wa], [xa + ha + markShiftThree, ya - wa]),//左上角
          "WALine1": new makerjs.paths.Line([xa+ha + markShift, ya], [xa + ha + markShift, ya - wa]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa+ha + da + markShift, ya], [xa + ha + da + markShift, ya - w1a]),
          "W1ALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftThree, ya - w1a]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa, ya-w2a], [xa + ra + h1a + h1a + markShiftFour, ya - w2a]),
          "W2ALine1": new makerjs.paths.Line([xa + ha + ha + markShiftThree, ya], [xa +  ha + ha + markShiftThree, ya - w2a]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa, ya+ markShiftFour]),
          "HALine1": new makerjs.paths.Line([xa+ ha, ya ], [xa + ha, ya + markShiftFour]),//左上角
          "HALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa + ha, ya + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa+h1a, ya -  w1a + ra], [xa +h1a , ya - w2a - ra - markShiftFour]),
          "H1ALine1": new makerjs.paths.Line([xa, ya- w2a - markShift], [xa + h1a , ya - w2a- markShift]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa +ha , ya - wa - (wa / 2)], [xa + ha - markShiftTwo, ya - wa - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD]),//左上角
        }
      };
 
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi - hi, yi], [xi - hi - markShiftThree, yi]),//左上角
          "WILine1": new makerjs.paths.Line([xi - hi, yi + wi], [xi - hi - markShiftThree, yi + wi]),//左上角
          "WILine2": new makerjs.paths.Line([xi - hi - markShift, yi], [xi - hi - markShift, yi + wi]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi - hi - di - markShift, yi], [xi - hi - di - markShift, yi + w1i]),
          "W1ILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftThree, yi + w1i]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi - hi - hi - markShiftThree, yi], [xi - hi - hi - markShiftThree, yi + w2i]),
          "W2ILine1": new makerjs.paths.Line([xi, yi + w2i], [xi - hi - hi - di - markShiftFour, yi + w2i]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
          "HILine1": new makerjs.paths.Line([xi - hi, yi], [xi - hi, yi - markShiftFour]),//左上角
          "HILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - hi, yi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i, yi + w1i + di / 2 + markShiftFour]),
          "H1ILine1": new makerjs.paths.Line([xi, yi + w2i + markShift], [xi - h1i, yi + w2i + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
     
     
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa + ha + markShiftThree, ya - wa], [xa + ha + markShiftThree, ya]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa + ha  + da+ markShiftThree, ya - w1a], [xa + ha + da + markShiftThree, ya]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa + ha + ha + da + markShiftThree, ya - w2a], [xa + ha + ha + da + markShiftThree, ya]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa, ya + markShiftFour], [xa + ha, ya + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa, ya - w2a - markShiftThree], [xa + h1a, ya - w2a - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + ha - markShiftTwo, ya - wa - markShiftFour], [xa + ha, ya - wa - (wa / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markHolesOneD - markShiftFour]);//D文字标注  
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
    makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - hi - markShiftThree, yi + wi], [xi - hi - markShiftThree, yi]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - hi - di - markShiftThree, yi + w1i], [xi - hi - di - markShiftThree, yi]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - hi - hi - di - markShiftFour, yi + w2i], [xi - hi - hi - di - markShiftFour, yi]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi - hi, yi - markShiftFour], [xi, yi - markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - h1i, yi + w2i + markShiftThree], [xi, yi + w2i + markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markHolesOneD + markShiftFour], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]);//D文字标注  

      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /**G */
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "CG") {
     
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc - hc, yc], [xc - hc - markShiftThree, yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - hc, yc - wc], [xc - hc - markShiftThree, yc - wc]),//左上角
          "WCLine2": new makerjs.paths.Line([xc - hc - markShift, yc], [xc - hc - markShift, yc - wc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc - hc - dc - markShift, yc], [xc - hc - dc - markShift, yc - w1c]),
          "W1CLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftThree, yc - w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc - hc - hc - markShiftThree, yc], [xc - hc - hc - markShiftThree, yc - w2c]),
          "W2CLine1": new makerjs.paths.Line([xc, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc - w2c]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
          "HCLine1": new makerjs.paths.Line([xc - hc, yc], [xc - hc, yc + markShiftFour]),//左上角
          "HCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - hc, yc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c, yc - w1c - dc / 2 - markShiftFour]),
          "H1CLine1": new makerjs.paths.Line([xc, yc - w2c - markShift], [xc - h1c, yc - w2c - markShift]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]),//左上角
        }
      };
  
     
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg + hg, yg], [xg + hg + markShiftThree, yg]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + hg, yg + wg], [xg + hg + markShiftThree, yg + wg]),//左上角
          "WGLine2": new makerjs.paths.Line([xg + hg + markShift, yg], [xg + hg + markShift, yg + wg]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg + hg + dg + markShift, yg], [xg + hg + dg + markShift, yg + w1g]),
          "W1GLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftThree, yg + w1g]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg + hg + hg + markShiftThree, yg], [xg + hg + hg + markShiftThree, yg + w2g]),
          "W2GLine1": new makerjs.paths.Line([xg, yg + w2g], [xg + hg + hg + dg + markShiftFour, yg + w2g]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
          "HGLine1": new makerjs.paths.Line([xg + hg, yg], [xg + hg, yg - markShiftFour]),//左上角
          "HGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + hg, yg - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g, yg + w1g + dg / 2 + markShiftFour]),
          "H1GLine1": new makerjs.paths.Line([xg, yg + w2g + markShift], [xg + h1g, yg + w2g + markShift]),//左上角
        }
      };  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + hg, yg + wg + (wg / 2)], [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD]),//左上角
        }
      };
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - hc - markShiftThree, yc - wc], [xc - hc - markShiftThree, yc]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - hc - dc - markShiftThree, yc - w1c], [xc - hc - dc - markShiftThree, yc]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - hc - hc - dc - markShiftFour, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc - hc, yc + markShiftFour], [xc, yc + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - h1c, yc - w2c - markShiftThree], [xc, yc - w2c - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markHolesOneD - markShiftFour], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]);//D文字标注
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg + hg + markShiftThree, yg], [xg + hg + markShiftThree, yg + wg]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg + hg + dg + markShiftThree, yg], [xg + hg + dg + markShiftThree, yg + w1g]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg + hg + hg + dg + markShiftFour, yg], [xg + hg + hg + dg + markShiftFour, yg + w2g]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg, yg - markShiftFour], [xg + hg, yg - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg, yg + w2g + markShiftThree], [xg + h1g, yg + w2g + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour], [xg + hg, yg + wg + (wg / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markHolesOneD + markShiftFour]);//D文字标注  
   
      /******************************************************************** */
      var markers = {
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
  
      }
    } else if (area == "CI") {
     
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc - hc, yc], [xc - hc - markShiftThree, yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - hc, yc - wc], [xc - hc - markShiftThree, yc - wc]),//左上角
          "WCLine2": new makerjs.paths.Line([xc - hc - markShift, yc], [xc - hc - markShift, yc - wc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc - hc - dc - markShift, yc], [xc - hc - dc - markShift, yc - w1c]),
          "W1CLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftThree, yc - w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc - hc - hc - markShiftThree, yc], [xc - hc - hc - markShiftThree, yc - w2c]),
          "W2CLine1": new makerjs.paths.Line([xc, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc - w2c]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
          "HCLine1": new makerjs.paths.Line([xc - hc, yc], [xc - hc, yc + markShiftFour]),//左上角
          "HCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - hc, yc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c, yc - w1c - dc / 2 - markShiftFour]),
          "H1CLine1": new makerjs.paths.Line([xc, yc - w2c - markShift], [xc - h1c, yc - w2c - markShift]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]),//左上角
        }
      };
  
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi - hi, yi], [xi - hi - markShiftThree, yi]),//左上角
          "WILine1": new makerjs.paths.Line([xi - hi, yi + wi], [xi - hi - markShiftThree, yi + wi]),//左上角
          "WILine2": new makerjs.paths.Line([xi - hi - markShift, yi], [xi - hi - markShift, yi + wi]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi - hi - di - markShift, yi], [xi - hi - di - markShift, yi + w1i]),
          "W1ILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftThree, yi + w1i]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi - hi - hi - markShiftThree, yi], [xi - hi - hi - markShiftThree, yi + w2i]),
          "W2ILine1": new makerjs.paths.Line([xi, yi + w2i], [xi - hi - hi - di - markShiftFour, yi + w2i]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
          "HILine1": new makerjs.paths.Line([xi - hi, yi], [xi - hi, yi - markShiftFour]),//左上角
          "HILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - hi, yi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i, yi + w1i + di / 2 + markShiftFour]),
          "H1ILine1": new makerjs.paths.Line([xi, yi + w2i + markShift], [xi - h1i, yi + w2i + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
     /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - hc - markShiftThree, yc - wc], [xc - hc - markShiftThree, yc]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - hc - dc - markShiftThree, yc - w1c], [xc - hc - dc - markShiftThree, yc]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - hc - hc - dc - markShiftFour, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc - hc, yc + markShiftFour], [xc, yc + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - h1c, yc - w2c - markShiftThree], [xc, yc - w2c - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markHolesOneD - markShiftFour], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]);//D文字标注
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
    makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - hi - markShiftThree, yi + wi], [xi - hi - markShiftThree, yi]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - hi - di - markShiftThree, yi + w1i], [xi - hi - di - markShiftThree, yi]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - hi - hi - di - markShiftFour, yi + w2i], [xi - hi - hi - di - markShiftFour, yi]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi - hi, yi - markShiftFour], [xi, yi - markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - h1i, yi + w2i + markShiftThree], [xi, yi + w2i + markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markHolesOneD + markShiftFour], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]);//D文字标注  

      /******************************************************************** */
      var markers = {
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "GI") {
     
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg + hg, yg], [xg + hg + markShiftThree, yg]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + hg, yg + wg], [xg + hg + markShiftThree, yg + wg]),//左上角
          "WGLine2": new makerjs.paths.Line([xg + hg + markShift, yg], [xg + hg + markShift, yg + wg]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg + hg + dg + markShift, yg], [xg + hg + dg + markShift, yg + w1g]),
          "W1GLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftThree, yg + w1g]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg + hg + hg + markShiftThree, yg], [xg + hg + hg + markShiftThree, yg + w2g]),
          "W2GLine1": new makerjs.paths.Line([xg, yg + w2g], [xg + hg + hg + dg + markShiftFour, yg + w2g]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
          "HGLine1": new makerjs.paths.Line([xg + hg, yg], [xg + hg, yg - markShiftFour]),//左上角
          "HGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + hg, yg - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g, yg + w1g + dg / 2 + markShiftFour]),
          "H1GLine1": new makerjs.paths.Line([xg, yg + w2g + markShift], [xg + h1g, yg + w2g + markShift]),//左上角
        }
      };  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + hg, yg + wg + (wg / 2)], [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi - hi, yi], [xi - hi - markShiftThree, yi]),//左上角
          "WILine1": new makerjs.paths.Line([xi - hi, yi + wi], [xi - hi - markShiftThree, yi + wi]),//左上角
          "WILine2": new makerjs.paths.Line([xi - hi - markShift, yi], [xi - hi - markShift, yi + wi]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi - hi - di - markShift, yi], [xi - hi - di - markShift, yi + w1i]),
          "W1ILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftThree, yi + w1i]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi - hi - hi - markShiftThree, yi], [xi - hi - hi - markShiftThree, yi + w2i]),
          "W2ILine1": new makerjs.paths.Line([xi, yi + w2i], [xi - hi - hi - di - markShiftFour, yi + w2i]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
          "HILine1": new makerjs.paths.Line([xi - hi, yi], [xi - hi, yi - markShiftFour]),//左上角
          "HILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - hi, yi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i, yi + w1i + di / 2 + markShiftFour]),
          "H1ILine1": new makerjs.paths.Line([xi, yi + w2i + markShift], [xi - h1i, yi + w2i + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg + hg + markShiftThree, yg], [xg + hg + markShiftThree, yg + wg]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg + hg + dg + markShiftThree, yg], [xg + hg + dg + markShiftThree, yg + w1g]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg + hg + hg + dg + markShiftFour, yg], [xg + hg + hg + dg + markShiftFour, yg + w2g]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg, yg - markShiftFour], [xg + hg, yg - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg, yg + w2g + markShiftThree], [xg + h1g, yg + w2g + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour], [xg + hg, yg + wg + (wg / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markHolesOneD + markShiftFour]);//D文字标注  
    /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
    makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - hi - markShiftThree, yi + wi], [xi - hi - markShiftThree, yi]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - hi - di - markShiftThree, yi + w1i], [xi - hi - di - markShiftThree, yi]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - hi - hi - di - markShiftFour, yi + w2i], [xi - hi - hi - di - markShiftFour, yi]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi - hi, yi - markShiftFour], [xi, yi - markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - h1i, yi + w2i + markShiftThree], [xi, yi + w2i + markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markHolesOneD + markShiftFour], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]);//D文字标注  

      /******************************************************************** */
      var markers = {
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "ACG") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + ha, ya - wa], [xa + ha + markShiftThree, ya - wa]),//左上角
          "WALine1": new makerjs.paths.Line([xa+ha + markShift, ya], [xa + ha + markShift, ya - wa]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa+ha + da + markShift, ya], [xa + ha + da + markShift, ya - w1a]),
          "W1ALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftThree, ya - w1a]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa, ya-w2a], [xa + ra + h1a + h1a + markShiftFour, ya - w2a]),
          "W2ALine1": new makerjs.paths.Line([xa + ha + ha + markShiftThree, ya], [xa +  ha + ha + markShiftThree, ya - w2a]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa, ya+ markShiftFour]),
          "HALine1": new makerjs.paths.Line([xa+ ha, ya ], [xa + ha, ya + markShiftFour]),//左上角
          "HALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa + ha, ya + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa+h1a, ya -  w1a + ra], [xa +h1a , ya - w2a - ra - markShiftFour]),
          "H1ALine1": new makerjs.paths.Line([xa, ya- w2a - markShift], [xa + h1a , ya - w2a- markShift]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa +ha , ya - wa - (wa / 2)], [xa + ha - markShiftTwo, ya - wa - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD]),//左上角
        }
      };
     
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc - hc, yc], [xc - hc - markShiftThree, yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - hc, yc - wc], [xc - hc - markShiftThree, yc - wc]),//左上角
          "WCLine2": new makerjs.paths.Line([xc - hc - markShift, yc], [xc - hc - markShift, yc - wc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc - hc - dc - markShift, yc], [xc - hc - dc - markShift, yc - w1c]),
          "W1CLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftThree, yc - w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc - hc - hc - markShiftThree, yc], [xc - hc - hc - markShiftThree, yc - w2c]),
          "W2CLine1": new makerjs.paths.Line([xc, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc - w2c]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
          "HCLine1": new makerjs.paths.Line([xc - hc, yc], [xc - hc, yc + markShiftFour]),//左上角
          "HCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - hc, yc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c, yc - w1c - dc / 2 - markShiftFour]),
          "H1CLine1": new makerjs.paths.Line([xc, yc - w2c - markShift], [xc - h1c, yc - w2c - markShift]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]),//左上角
        }
      };
  
     
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg + hg, yg], [xg + hg + markShiftThree, yg]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + hg, yg + wg], [xg + hg + markShiftThree, yg + wg]),//左上角
          "WGLine2": new makerjs.paths.Line([xg + hg + markShift, yg], [xg + hg + markShift, yg + wg]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg + hg + dg + markShift, yg], [xg + hg + dg + markShift, yg + w1g]),
          "W1GLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftThree, yg + w1g]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg + hg + hg + markShiftThree, yg], [xg + hg + hg + markShiftThree, yg + w2g]),
          "W2GLine1": new makerjs.paths.Line([xg, yg + w2g], [xg + hg + hg + dg + markShiftFour, yg + w2g]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
          "HGLine1": new makerjs.paths.Line([xg + hg, yg], [xg + hg, yg - markShiftFour]),//左上角
          "HGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + hg, yg - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g, yg + w1g + dg / 2 + markShiftFour]),
          "H1GLine1": new makerjs.paths.Line([xg, yg + w2g + markShift], [xg + h1g, yg + w2g + markShift]),//左上角
        }
      };  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + hg, yg + wg + (wg / 2)], [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD]),//左上角
        }
      };
    
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa + ha + markShiftThree, ya - wa], [xa + ha + markShiftThree, ya]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa + ha  + da+ markShiftThree, ya - w1a], [xa + ha + da + markShiftThree, ya]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa + ha + ha + da + markShiftThree, ya - w2a], [xa + ha + ha + da + markShiftThree, ya]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa, ya + markShiftFour], [xa + ha, ya + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa, ya - w2a - markShiftThree], [xa + h1a, ya - w2a - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + ha - markShiftTwo, ya - wa - markShiftFour], [xa + ha, ya - wa - (wa / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markHolesOneD - markShiftFour]);//D文字标注  
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - hc - markShiftThree, yc - wc], [xc - hc - markShiftThree, yc]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - hc - dc - markShiftThree, yc - w1c], [xc - hc - dc - markShiftThree, yc]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - hc - hc - dc - markShiftFour, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc - hc, yc + markShiftFour], [xc, yc + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - h1c, yc - w2c - markShiftThree], [xc, yc - w2c - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markHolesOneD - markShiftFour], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]);//D文字标注
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg + hg + markShiftThree, yg], [xg + hg + markShiftThree, yg + wg]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg + hg + dg + markShiftThree, yg], [xg + hg + dg + markShiftThree, yg + w1g]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg + hg + hg + dg + markShiftFour, yg], [xg + hg + hg + dg + markShiftFour, yg + w2g]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg, yg - markShiftFour], [xg + hg, yg - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg, yg + w2g + markShiftThree], [xg + h1g, yg + w2g + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour], [xg + hg, yg + wg + (wg / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markHolesOneD + markShiftFour]);//D文字标注  
   
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
  
      }
    } else if (area == "ACI") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + ha, ya - wa], [xa + ha + markShiftThree, ya - wa]),//左上角
          "WALine1": new makerjs.paths.Line([xa+ha + markShift, ya], [xa + ha + markShift, ya - wa]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa+ha + da + markShift, ya], [xa + ha + da + markShift, ya - w1a]),
          "W1ALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftThree, ya - w1a]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa, ya-w2a], [xa + ra + h1a + h1a + markShiftFour, ya - w2a]),
          "W2ALine1": new makerjs.paths.Line([xa + ha + ha + markShiftThree, ya], [xa +  ha + ha + markShiftThree, ya - w2a]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa, ya+ markShiftFour]),
          "HALine1": new makerjs.paths.Line([xa+ ha, ya ], [xa + ha, ya + markShiftFour]),//左上角
          "HALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa + ha, ya + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa+h1a, ya -  w1a + ra], [xa +h1a , ya - w2a - ra - markShiftFour]),
          "H1ALine1": new makerjs.paths.Line([xa, ya- w2a - markShift], [xa + h1a , ya - w2a- markShift]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa +ha , ya - wa - (wa / 2)], [xa + ha - markShiftTwo, ya - wa - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD]),//左上角
        }
      };
     
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc - hc, yc], [xc - hc - markShiftThree, yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - hc, yc - wc], [xc - hc - markShiftThree, yc - wc]),//左上角
          "WCLine2": new makerjs.paths.Line([xc - hc - markShift, yc], [xc - hc - markShift, yc - wc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc - hc - dc - markShift, yc], [xc - hc - dc - markShift, yc - w1c]),
          "W1CLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftThree, yc - w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc - hc - hc - markShiftThree, yc], [xc - hc - hc - markShiftThree, yc - w2c]),
          "W2CLine1": new makerjs.paths.Line([xc, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc - w2c]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
          "HCLine1": new makerjs.paths.Line([xc - hc, yc], [xc - hc, yc + markShiftFour]),//左上角
          "HCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - hc, yc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c, yc - w1c - dc / 2 - markShiftFour]),
          "H1CLine1": new makerjs.paths.Line([xc, yc - w2c - markShift], [xc - h1c, yc - w2c - markShift]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]),//左上角
        }
      };
  
     
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi - hi, yi], [xi - hi - markShiftThree, yi]),//左上角
          "WILine1": new makerjs.paths.Line([xi - hi, yi + wi], [xi - hi - markShiftThree, yi + wi]),//左上角
          "WILine2": new makerjs.paths.Line([xi - hi - markShift, yi], [xi - hi - markShift, yi + wi]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi - hi - di - markShift, yi], [xi - hi - di - markShift, yi + w1i]),
          "W1ILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftThree, yi + w1i]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi - hi - hi - markShiftThree, yi], [xi - hi - hi - markShiftThree, yi + w2i]),
          "W2ILine1": new makerjs.paths.Line([xi, yi + w2i], [xi - hi - hi - di - markShiftFour, yi + w2i]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
          "HILine1": new makerjs.paths.Line([xi - hi, yi], [xi - hi, yi - markShiftFour]),//左上角
          "HILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - hi, yi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i, yi + w1i + di / 2 + markShiftFour]),
          "H1ILine1": new makerjs.paths.Line([xi, yi + w2i + markShift], [xi - h1i, yi + w2i + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
     
     
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa + ha + markShiftThree, ya - wa], [xa + ha + markShiftThree, ya]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa + ha  + da+ markShiftThree, ya - w1a], [xa + ha + da + markShiftThree, ya]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa + ha + ha + da + markShiftThree, ya - w2a], [xa + ha + ha + da + markShiftThree, ya]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa, ya + markShiftFour], [xa + ha, ya + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa, ya - w2a - markShiftThree], [xa + h1a, ya - w2a - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + ha - markShiftTwo, ya - wa - markShiftFour], [xa + ha, ya - wa - (wa / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markHolesOneD - markShiftFour]);//D文字标注  
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - hc - markShiftThree, yc - wc], [xc - hc - markShiftThree, yc]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - hc - dc - markShiftThree, yc - w1c], [xc - hc - dc - markShiftThree, yc]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - hc - hc - dc - markShiftFour, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc - hc, yc + markShiftFour], [xc, yc + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - h1c, yc - w2c - markShiftThree], [xc, yc - w2c - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markHolesOneD - markShiftFour], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]);//D文字标注
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
    makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - hi - markShiftThree, yi + wi], [xi - hi - markShiftThree, yi]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - hi - di - markShiftThree, yi + w1i], [xi - hi - di - markShiftThree, yi]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - hi - hi - di - markShiftFour, yi + w2i], [xi - hi - hi - di - markShiftFour, yi]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi - hi, yi - markShiftFour], [xi, yi - markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - h1i, yi + w2i + markShiftThree], [xi, yi + w2i + markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markHolesOneD + markShiftFour], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]);//D文字标注  
 
      
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "AGI") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + ha, ya - wa], [xa + ha + markShiftThree, ya - wa]),//左上角
          "WALine1": new makerjs.paths.Line([xa+ha + markShift, ya], [xa + ha + markShift, ya - wa]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa+ha + da + markShift, ya], [xa + ha + da + markShift, ya - w1a]),
          "W1ALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftThree, ya - w1a]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa, ya-w2a], [xa + ra + h1a + h1a + markShiftFour, ya - w2a]),
          "W2ALine1": new makerjs.paths.Line([xa + ha + ha + markShiftThree, ya], [xa +  ha + ha + markShiftThree, ya - w2a]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa, ya+ markShiftFour]),
          "HALine1": new makerjs.paths.Line([xa+ ha, ya ], [xa + ha, ya + markShiftFour]),//左上角
          "HALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa + ha, ya + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa+h1a, ya -  w1a + ra], [xa +h1a , ya - w2a - ra - markShiftFour]),
          "H1ALine1": new makerjs.paths.Line([xa, ya- w2a - markShift], [xa + h1a , ya - w2a- markShift]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa +ha , ya - wa - (wa / 2)], [xa + ha - markShiftTwo, ya - wa - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD]),//左上角
        }
      };
     
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg + hg, yg], [xg + hg + markShiftThree, yg]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + hg, yg + wg], [xg + hg + markShiftThree, yg + wg]),//左上角
          "WGLine2": new makerjs.paths.Line([xg + hg + markShift, yg], [xg + hg + markShift, yg + wg]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg + hg + dg + markShift, yg], [xg + hg + dg + markShift, yg + w1g]),
          "W1GLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftThree, yg + w1g]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg + hg + hg + markShiftThree, yg], [xg + hg + hg + markShiftThree, yg + w2g]),
          "W2GLine1": new makerjs.paths.Line([xg, yg + w2g], [xg + hg + hg + dg + markShiftFour, yg + w2g]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
          "HGLine1": new makerjs.paths.Line([xg + hg, yg], [xg + hg, yg - markShiftFour]),//左上角
          "HGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + hg, yg - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g, yg + w1g + dg / 2 + markShiftFour]),
          "H1GLine1": new makerjs.paths.Line([xg, yg + w2g + markShift], [xg + h1g, yg + w2g + markShift]),//左上角
        }
      };  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + hg, yg + wg + (wg / 2)], [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi - hi, yi], [xi - hi - markShiftThree, yi]),//左上角
          "WILine1": new makerjs.paths.Line([xi - hi, yi + wi], [xi - hi - markShiftThree, yi + wi]),//左上角
          "WILine2": new makerjs.paths.Line([xi - hi - markShift, yi], [xi - hi - markShift, yi + wi]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi - hi - di - markShift, yi], [xi - hi - di - markShift, yi + w1i]),
          "W1ILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftThree, yi + w1i]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi - hi - hi - markShiftThree, yi], [xi - hi - hi - markShiftThree, yi + w2i]),
          "W2ILine1": new makerjs.paths.Line([xi, yi + w2i], [xi - hi - hi - di - markShiftFour, yi + w2i]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
          "HILine1": new makerjs.paths.Line([xi - hi, yi], [xi - hi, yi - markShiftFour]),//左上角
          "HILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - hi, yi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i, yi + w1i + di / 2 + markShiftFour]),
          "H1ILine1": new makerjs.paths.Line([xi, yi + w2i + markShift], [xi - h1i, yi + w2i + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
     
     
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa + ha + markShiftThree, ya - wa], [xa + ha + markShiftThree, ya]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa + ha  + da+ markShiftThree, ya - w1a], [xa + ha + da + markShiftThree, ya]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa + ha + ha + da + markShiftThree, ya - w2a], [xa + ha + ha + da + markShiftThree, ya]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa, ya + markShiftFour], [xa + ha, ya + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa, ya - w2a - markShiftThree], [xa + h1a, ya - w2a - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + ha - markShiftTwo, ya - wa - markShiftFour], [xa + ha, ya - wa - (wa / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markHolesOneD - markShiftFour]);//D文字标注  
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg + hg + markShiftThree, yg], [xg + hg + markShiftThree, yg + wg]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg + hg + dg + markShiftThree, yg], [xg + hg + dg + markShiftThree, yg + w1g]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg + hg + hg + dg + markShiftFour, yg], [xg + hg + hg + dg + markShiftFour, yg + w2g]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg, yg - markShiftFour], [xg + hg, yg - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg, yg + w2g + markShiftThree], [xg + h1g, yg + w2g + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour], [xg + hg, yg + wg + (wg / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markHolesOneD + markShiftFour]);//D文字标注  
    /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
    makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - hi - markShiftThree, yi + wi], [xi - hi - markShiftThree, yi]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - hi - di - markShiftThree, yi + w1i], [xi - hi - di - markShiftThree, yi]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - hi - hi - di - markShiftFour, yi + w2i], [xi - hi - hi - di - markShiftFour, yi]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi - hi, yi - markShiftFour], [xi, yi - markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - h1i, yi + w2i + markShiftThree], [xi, yi + w2i + markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markHolesOneD + markShiftFour], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]);//D文字标注  
 
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "CGI") {
    
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc - hc, yc], [xc - hc - markShiftThree, yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - hc, yc - wc], [xc - hc - markShiftThree, yc - wc]),//左上角
          "WCLine2": new makerjs.paths.Line([xc - hc - markShift, yc], [xc - hc - markShift, yc - wc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc - hc - dc - markShift, yc], [xc - hc - dc - markShift, yc - w1c]),
          "W1CLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftThree, yc - w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc - hc - hc - markShiftThree, yc], [xc - hc - hc - markShiftThree, yc - w2c]),
          "W2CLine1": new makerjs.paths.Line([xc, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc - w2c]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
          "HCLine1": new makerjs.paths.Line([xc - hc, yc], [xc - hc, yc + markShiftFour]),//左上角
          "HCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - hc, yc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c, yc - w1c - dc / 2 - markShiftFour]),
          "H1CLine1": new makerjs.paths.Line([xc, yc - w2c - markShift], [xc - h1c, yc - w2c - markShift]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]),//左上角
        }
      };
  
     
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg + hg, yg], [xg + hg + markShiftThree, yg]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + hg, yg + wg], [xg + hg + markShiftThree, yg + wg]),//左上角
          "WGLine2": new makerjs.paths.Line([xg + hg + markShift, yg], [xg + hg + markShift, yg + wg]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg + hg + dg + markShift, yg], [xg + hg + dg + markShift, yg + w1g]),
          "W1GLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftThree, yg + w1g]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg + hg + hg + markShiftThree, yg], [xg + hg + hg + markShiftThree, yg + w2g]),
          "W2GLine1": new makerjs.paths.Line([xg, yg + w2g], [xg + hg + hg + dg + markShiftFour, yg + w2g]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
          "HGLine1": new makerjs.paths.Line([xg + hg, yg], [xg + hg, yg - markShiftFour]),//左上角
          "HGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + hg, yg - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g, yg + w1g + dg / 2 + markShiftFour]),
          "H1GLine1": new makerjs.paths.Line([xg, yg + w2g + markShift], [xg + h1g, yg + w2g + markShift]),//左上角
        }
      };  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + hg, yg + wg + (wg / 2)], [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi - hi, yi], [xi - hi - markShiftThree, yi]),//左上角
          "WILine1": new makerjs.paths.Line([xi - hi, yi + wi], [xi - hi - markShiftThree, yi + wi]),//左上角
          "WILine2": new makerjs.paths.Line([xi - hi - markShift, yi], [xi - hi - markShift, yi + wi]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi - hi - di - markShift, yi], [xi - hi - di - markShift, yi + w1i]),
          "W1ILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftThree, yi + w1i]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi - hi - hi - markShiftThree, yi], [xi - hi - hi - markShiftThree, yi + w2i]),
          "W2ILine1": new makerjs.paths.Line([xi, yi + w2i], [xi - hi - hi - di - markShiftFour, yi + w2i]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
          "HILine1": new makerjs.paths.Line([xi - hi, yi], [xi - hi, yi - markShiftFour]),//左上角
          "HILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - hi, yi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i, yi + w1i + di / 2 + markShiftFour]),
          "H1ILine1": new makerjs.paths.Line([xi, yi + w2i + markShift], [xi - h1i, yi + w2i + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - hc - markShiftThree, yc - wc], [xc - hc - markShiftThree, yc]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - hc - dc - markShiftThree, yc - w1c], [xc - hc - dc - markShiftThree, yc]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - hc - hc - dc - markShiftFour, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc - hc, yc + markShiftFour], [xc, yc + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - h1c, yc - w2c - markShiftThree], [xc, yc - w2c - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markHolesOneD - markShiftFour], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]);//D文字标注
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg + hg + markShiftThree, yg], [xg + hg + markShiftThree, yg + wg]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg + hg + dg + markShiftThree, yg], [xg + hg + dg + markShiftThree, yg + w1g]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg + hg + hg + dg + markShiftFour, yg], [xg + hg + hg + dg + markShiftFour, yg + w2g]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg, yg - markShiftFour], [xg + hg, yg - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg, yg + w2g + markShiftThree], [xg + h1g, yg + w2g + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour], [xg + hg, yg + wg + (wg / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markHolesOneD + markShiftFour]);//D文字标注  
    /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
    makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - hi - markShiftThree, yi + wi], [xi - hi - markShiftThree, yi]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - hi - di - markShiftThree, yi + w1i], [xi - hi - di - markShiftThree, yi]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - hi - hi - di - markShiftFour, yi + w2i], [xi - hi - hi - di - markShiftFour, yi]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi - hi, yi - markShiftFour], [xi, yi - markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - h1i, yi + w2i + markShiftThree], [xi, yi + w2i + markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markHolesOneD + markShiftFour], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]);//D文字标注  

      /******************************************************************** */
      var markers = {
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "ACGI") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + ha, ya - wa], [xa + ha + markShiftThree, ya - wa]),//左上角
          "WALine1": new makerjs.paths.Line([xa+ha + markShift, ya], [xa + ha + markShift, ya - wa]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa+ha + da + markShift, ya], [xa + ha + da + markShift, ya - w1a]),
          "W1ALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftThree, ya - w1a]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa, ya-w2a], [xa + ra + h1a + h1a + markShiftFour, ya - w2a]),
          "W2ALine1": new makerjs.paths.Line([xa + ha + ha + markShiftThree, ya], [xa +  ha + ha + markShiftThree, ya - w2a]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa, ya+ markShiftFour]),
          "HALine1": new makerjs.paths.Line([xa+ ha, ya ], [xa + ha, ya + markShiftFour]),//左上角
          "HALine2": new makerjs.paths.Line([xa, ya+ markShiftTwo], [xa + ha, ya + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa+h1a, ya -  w1a + ra], [xa +h1a , ya - w2a - ra - markShiftFour]),
          "H1ALine1": new makerjs.paths.Line([xa, ya- w2a - markShift], [xa + h1a , ya - w2a- markShift]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa +ha , ya - wa - (wa / 2)], [xa + ha - markShiftTwo, ya - wa - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + h1a, ya - w1a], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD]),//左上角
        }
      };
     
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc - hc, yc], [xc - hc - markShiftThree, yc]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - hc, yc - wc], [xc - hc - markShiftThree, yc - wc]),//左上角
          "WCLine2": new makerjs.paths.Line([xc - hc - markShift, yc], [xc - hc - markShift, yc - wc]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc - hc - dc - markShift, yc], [xc - hc - dc - markShift, yc - w1c]),
          "W1CLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftThree, yc - w1c]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc - hc - hc - markShiftThree, yc], [xc - hc - hc - markShiftThree, yc - w2c]),
          "W2CLine1": new makerjs.paths.Line([xc, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc - w2c]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
          "HCLine1": new makerjs.paths.Line([xc - hc, yc], [xc - hc, yc + markShiftFour]),//左上角
          "HCLine2": new makerjs.paths.Line([xc, yc + markShiftTwo], [xc - hc, yc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c, yc - w1c - dc / 2 - markShiftFour]),
          "H1CLine1": new makerjs.paths.Line([xc, yc - w2c - markShift], [xc - h1c, yc - w2c - markShift]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - h1c, yc - w1c], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]),//左上角
        }
      };
  
     
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg + hg, yg], [xg + hg + markShiftThree, yg]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + hg, yg + wg], [xg + hg + markShiftThree, yg + wg]),//左上角
          "WGLine2": new makerjs.paths.Line([xg + hg + markShift, yg], [xg + hg + markShift, yg + wg]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg + hg + dg + markShift, yg], [xg + hg + dg + markShift, yg + w1g]),
          "W1GLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftThree, yg + w1g]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg + hg + hg + markShiftThree, yg], [xg + hg + hg + markShiftThree, yg + w2g]),
          "W2GLine1": new makerjs.paths.Line([xg, yg + w2g], [xg + hg + hg + dg + markShiftFour, yg + w2g]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
          "HGLine1": new makerjs.paths.Line([xg + hg, yg], [xg + hg, yg - markShiftFour]),//左上角
          "HGLine2": new makerjs.paths.Line([xg, yg - markShiftTwo], [xg + hg, yg - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g, yg + w1g + dg / 2 + markShiftFour]),
          "H1GLine1": new makerjs.paths.Line([xg, yg + w2g + markShift], [xg + h1g, yg + w2g + markShift]),//左上角
        }
      };  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + hg, yg + wg + (wg / 2)], [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + h1g, yg + w1g], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi - hi, yi], [xi - hi - markShiftThree, yi]),//左上角
          "WILine1": new makerjs.paths.Line([xi - hi, yi + wi], [xi - hi - markShiftThree, yi + wi]),//左上角
          "WILine2": new makerjs.paths.Line([xi - hi - markShift, yi], [xi - hi - markShift, yi + wi]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi - hi - di - markShift, yi], [xi - hi - di - markShift, yi + w1i]),
          "W1ILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftThree, yi + w1i]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi - hi - hi - markShiftThree, yi], [xi - hi - hi - markShiftThree, yi + w2i]),
          "W2ILine1": new makerjs.paths.Line([xi, yi + w2i], [xi - hi - hi - di - markShiftFour, yi + w2i]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
          "HILine1": new makerjs.paths.Line([xi - hi, yi], [xi - hi, yi - markShiftFour]),//左上角
          "HILine2": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi - hi, yi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i, yi + w1i + di / 2 + markShiftFour]),
          "H1ILine1": new makerjs.paths.Line([xi, yi + w2i + markShift], [xi - h1i, yi + w2i + markShift]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - h1i, yi + w1i], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
     
     
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa + ha + markShiftThree, ya - wa], [xa + ha + markShiftThree, ya]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa + ha  + da+ markShiftThree, ya - w1a], [xa + ha + da + markShiftThree, ya]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa + ha + ha + da + markShiftThree, ya - w2a], [xa + ha + ha + da + markShiftThree, ya]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa, ya + markShiftFour], [xa + ha, ya + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa, ya - w2a - markShiftThree], [xa + h1a, ya - w2a - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + ha - markShiftTwo, ya - wa - markShiftFour], [xa + ha, ya - wa - (wa / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markShift - markHolesOneD], [xa + h1a + da + markShiftFour + markHolesOneD, ya - w1a - markHolesOneD - markShiftFour]);//D文字标注  
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - hc - markShiftThree, yc - wc], [xc - hc - markShiftThree, yc]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - hc - dc - markShiftThree, yc - w1c], [xc - hc - dc - markShiftThree, yc]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - hc - hc - dc - markShiftFour, yc - w2c], [xc - hc - hc - dc - markShiftFour, yc]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc - hc, yc + markShiftFour], [xc, yc + markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - h1c, yc - w2c - markShiftThree], [xc, yc - w2c - markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - hc, yc - wc - (wc / 2)], [xc - hc + markShiftTwo, yc - wc - markShiftFour]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markHolesOneD - markShiftFour], [xc - h1c - dc - markShiftFour - markHolesOneD, yc - w1c - markShift - markHolesOneD]);//D文字标注
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg + hg + markShiftThree, yg], [xg + hg + markShiftThree, yg + wg]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg + hg + dg + markShiftThree, yg], [xg + hg + dg + markShiftThree, yg + w1g]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg + hg + hg + dg + markShiftFour, yg], [xg + hg + hg + dg + markShiftFour, yg + w2g]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg, yg - markShiftFour], [xg + hg, yg - markShiftFour]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg, yg + w2g + markShiftThree], [xg + h1g, yg + w2g + markShiftThree]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + hg - markShiftThree, yg + wg + (wg / 2) - markShiftFour], [xg + hg, yg + wg + (wg / 2)]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markShift + markHolesOneD], [xg + h1g + dg + markShiftFour + markHolesOneD, yg + w1g + markHolesOneD + markShiftFour]);//D文字标注  
    /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
    makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - hi - markShiftThree, yi + wi], [xi - hi - markShiftThree, yi]);//半径文字  
    makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - hi - di - markShiftThree, yi + w1i], [xi - hi - di - markShiftThree, yi]);//W1文字标注 
    makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - hi - hi - di - markShiftFour, yi + w2i], [xi - hi - hi - di - markShiftFour, yi]);//W1文字标注
    makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi - hi, yi - markShiftFour], [xi, yi - markShiftFour]);//H文字标注
    makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - h1i, yi + w2i + markShiftThree], [xi, yi + w2i + markShiftThree]);//H1文字标注
    makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - hi, yi + wi + (wi / 2)], [xi - hi + markShiftTwo, yi + wi + markShiftFour]);//R1文字标注
    makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markHolesOneD + markShiftFour], [xi - h1i - di - markShiftFour - markHolesOneD, yi + w1i + markShift + markHolesOneD]);//D文字标注  

      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
  
  
      // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
    }
}else{
    console.log("creatFloorSpring2HMark=短边在X轴￥￥￥￥￥");
    if (area == "A") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + wa, ya - ha], [xa + wa, ya - ha - markShiftThree]),//左上角
          "WALine1": new makerjs.paths.Line([xa, ya - ha - markShift], [xa + wa, ya - ha - markShift]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa, ya - ha - da - markShift], [xa + w1a, ya - ha - da - markShift]),
          "W1ALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a, ya - h1a - da - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa + w2a, ya], [xa + w2a, ya - ra - h1a - h1a - markShiftFour]),
          "W2ALine1": new makerjs.paths.Line([xa, ya - ha - ha - markShiftThree], [xa + w2a, ya - ha - ha - markShiftThree]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa - markShiftFour, ya]),
          "HALine1": new makerjs.paths.Line([xa, ya - ha], [xa - markShiftFour, ya - ha]),//左上角
          "HALine2": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya - ha]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa + w1a - ra, ya - h1a], [xa + w2a + ra + markShiftFour, ya - h1a]),
          "H1ALine1": new makerjs.paths.Line([xa + w2a + markShift, ya], [xa + w2a + markShift, ya - h1a]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD]),//左上角
        }
      };
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa, ya - ha - markShiftThree], [xa + wa, ya - ha - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa, ya - ha - da - markShiftThree], [xa + w1a, ya - ha - da - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa, ya - ha - ha - da - markShiftThree], [xa + w2a, ya - ha - ha - da - markShiftThree]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa - markShiftFour, ya - ha], [xa - markShiftFour, ya]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa + w2a + markShiftThree, ya - h1a], [xa + w2a + markShiftThree, ya]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD], [xa + w1a + markHolesOneD + markShiftFour, ya - h1a - da - markShiftFour - markHolesOneD]);//D文字标注  
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
      }
  
    } else if (area == "C") {
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc, yc - hc], [xc, yc - hc - markShiftThree]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - wc, yc - hc], [xc - wc, yc - hc - markShiftThree]),//左上角
          "WCLine2": new makerjs.paths.Line([xc, yc - hc - markShift], [xc - wc, yc - hc - markShift]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc, yc - hc - dc - markShift], [xc - w1c, yc - hc - dc - markShift]),
          "W1CLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c, yc - h1c - dc - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc, yc - hc - hc - markShiftThree], [xc - w2c, yc - hc - hc - markShiftThree]),
          "W2CLine1": new makerjs.paths.Line([xc - w2c, yc], [xc - w2c, yc - hc - hc - dc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
          "HCLine1": new makerjs.paths.Line([xc, yc - hc], [xc + markShiftFour, yc - hc]),//左上角
          "HCLine2": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc - hc]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - dc / 2 - markShiftFour, yc - h1c]),
          "H1CLine1": new makerjs.paths.Line([xc - w2c - markShift, yc], [xc - w2c - markShift, yc - h1c]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]),//左上角
        }
      };
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - wc, yc - hc - markShiftThree], [xc, yc - hc - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - w1c, yc - hc - dc - markShiftThree], [xc, yc - hc - dc - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - w2c, yc - hc - hc - dc - markShiftFour], [xc, yc - hc - hc - dc - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc + markShiftFour, yc - hc], [xc + markShiftFour, yc]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - w2c - markShiftThree, yc - h1c], [xc - w2c - markShiftThree, yc]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - w1c - markHolesOneD - markShiftFour, yc - h1c - dc - markShiftFour - markHolesOneD], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]);//D文字标注  
     
      ////////////****************************** */
      var markers = {
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
      }
    } else if (area == "G") {
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg, yg + hg], [xg, yg + hg + markShiftThree]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + wg, yg + hg], [xg + wg, yg + hg + markShiftThree]),//左上角
          "WGLine2": new makerjs.paths.Line([xg, yg + hg + markShift], [xg + wg, yg + hg + markShift]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg, yg + hg + dg + markShift], [xg + w1g, yg + hg + dg + markShift]),
          "W1GLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g, yg + h1g + dg + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg, yg + hg + hg + markShiftThree], [xg + w2g, yg + hg + hg + markShiftThree]),
          "W2GLine1": new makerjs.paths.Line([xg + w2g, yg], [xg + w2g, yg + hg + hg + dg + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg - markShiftFour, yg]),
          "HGLine1": new makerjs.paths.Line([xg, yg + hg], [xg - markShiftFour, yg + hg]),//左上角
          "HGLine2": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg + hg]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + dg / 2 + markShiftFour, yg + h1g]),
          "H1GLine1": new makerjs.paths.Line([xg + w2g + markShift, yg], [xg + w2g + markShift, yg + h1g]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + wg + (wg / 2), yg + hg], [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD]),//左上角
        }
      };
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg, yg + hg + markShiftThree], [xg + wg, yg + hg + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg, yg + hg + dg + markShiftThree], [xg + w1g, yg + hg + dg + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg, yg + hg + hg + dg + markShiftFour], [xg + w2g, yg + hg + hg + dg + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg - markShiftFour, yg + hg], [xg - markShiftFour, yg]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg + w2g + markShiftThree, yg + h1g], [xg + w2g + markShiftThree, yg]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree], [xg + wg + (wg / 2), yg + hg]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD], [xg + w1g + markHolesOneD + markShiftFour, yg + h1g + dg + markShiftFour + markHolesOneD]);//D文字标注  
    
    /////////////////////******************************************** */
      var markers = {
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
      }
  
    } else if (area == "I") {
   
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi, yi + hi], [xi, yi + hi + markShiftThree]),//左上角
          "WILine1": new makerjs.paths.Line([xi - wi, yi + hi], [xi - wi, yi + hi + markShiftThree]),//左上角
          "WILine2": new makerjs.paths.Line([xi, yi + hi + markShift], [xi - wi, yi + hi + markShift]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi, yi + hi + di + markShift], [xi - w1i, yi + hi + di + markShift]),
          "W1ILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i, yi + h1i + di + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi, yi + hi + hi + markShiftThree], [xi - w2i, yi + hi + hi + markShiftThree]),
          "W2ILine1": new makerjs.paths.Line([xi - w2i, yi], [xi - w2i, yi + hi + hi + di + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
          "HILine1": new makerjs.paths.Line([xi, yi + hi], [xi + markShiftFour, yi + hi]),//左上角
          "HILine2": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi + hi]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - di / 2 - markShiftFour, yi + h1i]),
          "H1ILine1": new makerjs.paths.Line([xi - w2i - markShift, yi], [xi - w2i - markShift, yi + h1i]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
     
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - wi, yi + hi + markShiftThree], [xi, yi + hi + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - w1i, yi + hi + di + markShiftThree], [xi, yi + hi + di + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - w2i, yi + hi + hi + di + markShiftFour], [xi, yi + hi + hi + di + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi + markShiftFour, yi + hi], [xi + markShiftFour, yi]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - w2i - markShiftThree, yi + h1i], [xi - w2i - markShiftThree, yi]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - w1i - markHolesOneD - markShiftFour, yi + h1i + di + markShiftFour + markHolesOneD], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]);//D文字标注  
  /************************************************************************************** */
      var markers = {
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
      }
  
    } else if (area == "AC") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + wa, ya - ha], [xa + wa, ya - ha - markShiftThree]),//左上角
          "WALine1": new makerjs.paths.Line([xa, ya - ha - markShift], [xa + wa, ya - ha - markShift]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa, ya - ha - da - markShift], [xa + w1a, ya - ha - da - markShift]),
          "W1ALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a, ya - h1a - da - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa + w2a, ya], [xa + w2a, ya - ra - h1a - h1a - markShiftFour]),
          "W2ALine1": new makerjs.paths.Line([xa, ya - ha - ha - markShiftThree], [xa + w2a, ya - ha - ha - markShiftThree]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa - markShiftFour, ya]),
          "HALine1": new makerjs.paths.Line([xa, ya - ha], [xa - markShiftFour, ya - ha]),//左上角
          "HALine2": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya - ha]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa + w1a - ra, ya - h1a], [xa + w2a + ra + markShiftFour, ya - h1a]),
          "H1ALine1": new makerjs.paths.Line([xa + w2a + markShift, ya], [xa + w2a + markShift, ya - h1a]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc, yc - hc], [xc, yc - hc - markShiftThree]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - wc, yc - hc], [xc - wc, yc - hc - markShiftThree]),//左上角
          "WCLine2": new makerjs.paths.Line([xc, yc - hc - markShift], [xc - wc, yc - hc - markShift]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc, yc - hc - dc - markShift], [xc - w1c, yc - hc - dc - markShift]),
          "W1CLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c, yc - h1c - dc - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc, yc - hc - hc - markShiftThree], [xc - w2c, yc - hc - hc - markShiftThree]),
          "W2CLine1": new makerjs.paths.Line([xc - w2c, yc], [xc - w2c, yc - hc - hc - dc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
          "HCLine1": new makerjs.paths.Line([xc, yc - hc], [xc + markShiftFour, yc - hc]),//左上角
          "HCLine2": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc - hc]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - dc / 2 - markShiftFour, yc - h1c]),
          "H1CLine1": new makerjs.paths.Line([xc - w2c - markShift, yc], [xc - w2c - markShift, yc - h1c]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /********************************************** */
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa, ya - ha - markShiftThree], [xa + wa, ya - ha - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa, ya - ha - da - markShiftThree], [xa + w1a, ya - ha - da - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa, ya - ha - ha - ra - markShiftFour], [xa + w2a, ya - ha - ha - da - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa - markShiftFour, ya - ha], [xa - markShiftFour, ya]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa + w2a + markShiftThree, ya - h1a], [xa + w2a + markShiftThree, ya]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD], [xa + w1a + markHolesOneD + markShiftFour, ya - h1a - da - markShiftFour - markHolesOneD]);//D文字标注  
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - wc, yc - hc - markShiftThree], [xc, yc - hc - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - w1c, yc - hc - dc - markShiftThree], [xc, yc - hc - dc - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - w2c, yc - hc - hc - dc - markShiftFour], [xc, yc - hc - hc - dc - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc + markShiftFour, yc - hc], [xc + markShiftFour, yc]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - w2c - markShiftThree, yc - h1c], [xc - w2c - markShiftThree, yc]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - w1c - markHolesOneD - markShiftFour, yc - h1c - dc - markShiftFour - markHolesOneD], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]);//D文字标注  
     
     
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        /**I */
  
      }
  
    } else if (area == "AG") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + wa, ya - ha], [xa + wa, ya - ha - markShiftThree]),//左上角
          "WALine1": new makerjs.paths.Line([xa, ya - ha - markShift], [xa + wa, ya - ha - markShift]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa, ya - ha - da - markShift], [xa + w1a, ya - ha - da - markShift]),
          "W1ALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a, ya - h1a - da - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa + w2a, ya], [xa + w2a, ya - ra - h1a - h1a - markShiftFour]),
          "W2ALine1": new makerjs.paths.Line([xa, ya - ha - ha - markShiftThree], [xa + w2a, ya - ha - ha - markShiftThree]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa - markShiftFour, ya]),
          "HALine1": new makerjs.paths.Line([xa, ya - ha], [xa - markShiftFour, ya - ha]),//左上角
          "HALine2": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya - ha]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa + w1a - ra, ya - h1a], [xa + w2a + ra + markShiftFour, ya - h1a]),
          "H1ALine1": new makerjs.paths.Line([xa + w2a + markShift, ya], [xa + w2a + markShift, ya - h1a]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD]),//左上角
        }
      };
     
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg, yg + hg], [xg, yg + hg + markShiftThree]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + wg, yg + hg], [xg + wg, yg + hg + markShiftThree]),//左上角
          "WGLine2": new makerjs.paths.Line([xg, yg + hg + markShift], [xg + wg, yg + hg + markShift]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg, yg + hg + dg + markShift], [xg + w1g, yg + hg + dg + markShift]),
          "W1GLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g, yg + h1g + dg + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg, yg + hg + hg + markShiftThree], [xg + w2g, yg + hg + hg + markShiftThree]),
          "W2GLine1": new makerjs.paths.Line([xg + w2g, yg], [xg + w2g, yg + hg + hg + dg + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg - markShiftFour, yg]),
          "HGLine1": new makerjs.paths.Line([xg, yg + hg], [xg - markShiftFour, yg + hg]),//左上角
          "HGLine2": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg + hg]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + dg / 2 + markShiftFour, yg + h1g]),
          "H1GLine1": new makerjs.paths.Line([xg + w2g + markShift, yg], [xg + w2g + markShift, yg + h1g]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + wg + (wg / 2), yg + hg], [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD]),//左上角
        }
      };
     
      /********************************************** */
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa, ya - ha - markShiftThree], [xa + wa, ya - ha - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa, ya - ha - da - markShiftThree], [xa + w1a, ya - ha - da - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa, ya - ha - ha - ra - markShiftFour], [xa + w2a, ya - ha - ha - da - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa - markShiftFour, ya - ha], [xa - markShiftFour, ya]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa + w2a + markShiftThree, ya - h1a], [xa + w2a + markShiftThree, ya]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD], [xa + w1a + markHolesOneD + markShiftFour, ya - h1a - da - markShiftFour - markHolesOneD]);//D文字标注  
    
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg, yg + hg + markShiftThree], [xg + wg, yg + hg + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg, yg + hg + dg + markShiftThree], [xg + w1g, yg + hg + dg + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg, yg + hg + hg + dg + markShiftFour], [xg + w2g, yg + hg + hg + dg + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg - markShiftFour, yg + hg], [xg - markShiftFour, yg]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg + w2g + markShiftThree, yg + h1g], [xg + w2g + markShiftThree, yg]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree], [xg + wg + (wg / 2), yg + hg]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD], [xg + w1g + markHolesOneD + markShiftFour, yg + h1g + dg + markShiftFour + markHolesOneD]);//D文字标注  
  
   
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
  
      }
    } else if (area == "AI") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + wa, ya - ha], [xa + wa, ya - ha - markShiftThree]),//左上角
          "WALine1": new makerjs.paths.Line([xa, ya - ha - markShift], [xa + wa, ya - ha - markShift]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa, ya - ha - da - markShift], [xa + w1a, ya - ha - da - markShift]),
          "W1ALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a, ya - h1a - da - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa + w2a, ya], [xa + w2a, ya - ra - h1a - h1a - markShiftFour]),
          "W2ALine1": new makerjs.paths.Line([xa, ya - ha - ha - markShiftThree], [xa + w2a, ya - ha - ha - markShiftThree]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa - markShiftFour, ya]),
          "HALine1": new makerjs.paths.Line([xa, ya - ha], [xa - markShiftFour, ya - ha]),//左上角
          "HALine2": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya - ha]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa + w1a - ra, ya - h1a], [xa + w2a + ra + markShiftFour, ya - h1a]),
          "H1ALine1": new makerjs.paths.Line([xa + w2a + markShift, ya], [xa + w2a + markShift, ya - h1a]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD]),//左上角
        }
      };
    
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi, yi + hi], [xi, yi + hi + markShiftThree]),//左上角
          "WILine1": new makerjs.paths.Line([xi - wi, yi + hi], [xi - wi, yi + hi + markShiftThree]),//左上角
          "WILine2": new makerjs.paths.Line([xi, yi + hi + markShift], [xi - wi, yi + hi + markShift]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi, yi + hi + di + markShift], [xi - w1i, yi + hi + di + markShift]),
          "W1ILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i, yi + h1i + di + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi, yi + hi + hi + markShiftThree], [xi - w2i, yi + hi + hi + markShiftThree]),
          "W2ILine1": new makerjs.paths.Line([xi - w2i, yi], [xi - w2i, yi + hi + hi + di + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
          "HILine1": new makerjs.paths.Line([xi, yi + hi], [xi + markShiftFour, yi + hi]),//左上角
          "HILine2": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi + hi]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - di / 2 - markShiftFour, yi + h1i]),
          "H1ILine1": new makerjs.paths.Line([xi - w2i - markShift, yi], [xi - w2i - markShift, yi + h1i]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa, ya - ha - markShiftThree], [xa + wa, ya - ha - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa, ya - ha - da - markShiftThree], [xa + w1a, ya - ha - da - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa, ya - ha - ha - ra - markShiftFour], [xa + w2a, ya - ha - ha - da - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa - markShiftFour, ya - ha], [xa - markShiftFour, ya]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa + w2a + markShiftThree, ya - h1a], [xa + w2a + markShiftThree, ya]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD], [xa + w1a + markHolesOneD + markShiftFour, ya - h1a - da - markShiftFour - markHolesOneD]);//D文字标注  
     
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - wi, yi + hi + markShiftThree], [xi, yi + hi + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - w1i, yi + hi + di + markShiftThree], [xi, yi + hi + di + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - w2i, yi + hi + hi + di + markShiftFour], [xi, yi + hi + hi + di + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi + markShiftFour, yi + hi], [xi + markShiftFour, yi]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - w2i - markShiftThree, yi + h1i], [xi - w2i - markShiftThree, yi]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - w1i - markHolesOneD - markShiftFour, yi + h1i + di + markShiftFour + markHolesOneD], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]);//D文字标注  
  
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /**G */
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "CG") {
   
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc, yc - hc], [xc, yc - hc - markShiftThree]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - wc, yc - hc], [xc - wc, yc - hc - markShiftThree]),//左上角
          "WCLine2": new makerjs.paths.Line([xc, yc - hc - markShift], [xc - wc, yc - hc - markShift]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc, yc - hc - dc - markShift], [xc - w1c, yc - hc - dc - markShift]),
          "W1CLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c, yc - h1c - dc - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc, yc - hc - hc - markShiftThree], [xc - w2c, yc - hc - hc - markShiftThree]),
          "W2CLine1": new makerjs.paths.Line([xc - w2c, yc], [xc - w2c, yc - hc - hc - dc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
          "HCLine1": new makerjs.paths.Line([xc, yc - hc], [xc + markShiftFour, yc - hc]),//左上角
          "HCLine2": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc - hc]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - dc / 2 - markShiftFour, yc - h1c]),
          "H1CLine1": new makerjs.paths.Line([xc - w2c - markShift, yc], [xc - w2c - markShift, yc - h1c]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg, yg + hg], [xg, yg + hg + markShiftThree]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + wg, yg + hg], [xg + wg, yg + hg + markShiftThree]),//左上角
          "WGLine2": new makerjs.paths.Line([xg, yg + hg + markShift], [xg + wg, yg + hg + markShift]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg, yg + hg + dg + markShift], [xg + w1g, yg + hg + dg + markShift]),
          "W1GLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g, yg + h1g + dg + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg, yg + hg + hg + markShiftThree], [xg + w2g, yg + hg + hg + markShiftThree]),
          "W2GLine1": new makerjs.paths.Line([xg + w2g, yg], [xg + w2g, yg + hg + hg + dg + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg - markShiftFour, yg]),
          "HGLine1": new makerjs.paths.Line([xg, yg + hg], [xg - markShiftFour, yg + hg]),//左上角
          "HGLine2": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg + hg]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + dg / 2 + markShiftFour, yg + h1g]),
          "H1GLine1": new makerjs.paths.Line([xg + w2g + markShift, yg], [xg + w2g + markShift, yg + h1g]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + wg + (wg / 2), yg + hg], [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD]),//左上角
        }
      };
    
      /********************************************** */
    
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - wc, yc - hc - markShiftThree], [xc, yc - hc - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - w1c, yc - hc - dc - markShiftThree], [xc, yc - hc - dc - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - w2c, yc - hc - hc - dc - markShiftFour], [xc, yc - hc - hc - dc - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc + markShiftFour, yc - hc], [xc + markShiftFour, yc]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - w2c - markShiftThree, yc - h1c], [xc - w2c - markShiftThree, yc]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - w1c - markHolesOneD - markShiftFour, yc - h1c - dc - markShiftFour - markHolesOneD], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]);//D文字标注  
     
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg, yg + hg + markShiftThree], [xg + wg, yg + hg + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg, yg + hg + dg + markShiftThree], [xg + w1g, yg + hg + dg + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg, yg + hg + hg + dg + markShiftFour], [xg + w2g, yg + hg + hg + dg + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg - markShiftFour, yg + hg], [xg - markShiftFour, yg]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg + w2g + markShiftThree, yg + h1g], [xg + w2g + markShiftThree, yg]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree], [xg + wg + (wg / 2), yg + hg]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD], [xg + w1g + markHolesOneD + markShiftFour, yg + h1g + dg + markShiftFour + markHolesOneD]);//D文字标注  
  
     
    
      /******************************************************************** */
      var markers = {
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
  
      }
    } else if (area == "CI") {
  
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc, yc - hc], [xc, yc - hc - markShiftThree]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - wc, yc - hc], [xc - wc, yc - hc - markShiftThree]),//左上角
          "WCLine2": new makerjs.paths.Line([xc, yc - hc - markShift], [xc - wc, yc - hc - markShift]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc, yc - hc - dc - markShift], [xc - w1c, yc - hc - dc - markShift]),
          "W1CLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c, yc - h1c - dc - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc, yc - hc - hc - markShiftThree], [xc - w2c, yc - hc - hc - markShiftThree]),
          "W2CLine1": new makerjs.paths.Line([xc - w2c, yc], [xc - w2c, yc - hc - hc - dc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
          "HCLine1": new makerjs.paths.Line([xc, yc - hc], [xc + markShiftFour, yc - hc]),//左上角
          "HCLine2": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc - hc]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - dc / 2 - markShiftFour, yc - h1c]),
          "H1CLine1": new makerjs.paths.Line([xc - w2c - markShift, yc], [xc - w2c - markShift, yc - h1c]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]),//左上角
        }
      };
     
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi, yi + hi], [xi, yi + hi + markShiftThree]),//左上角
          "WILine1": new makerjs.paths.Line([xi - wi, yi + hi], [xi - wi, yi + hi + markShiftThree]),//左上角
          "WILine2": new makerjs.paths.Line([xi, yi + hi + markShift], [xi - wi, yi + hi + markShift]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi, yi + hi + di + markShift], [xi - w1i, yi + hi + di + markShift]),
          "W1ILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i, yi + h1i + di + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi, yi + hi + hi + markShiftThree], [xi - w2i, yi + hi + hi + markShiftThree]),
          "W2ILine1": new makerjs.paths.Line([xi - w2i, yi], [xi - w2i, yi + hi + hi + di + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
          "HILine1": new makerjs.paths.Line([xi, yi + hi], [xi + markShiftFour, yi + hi]),//左上角
          "HILine2": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi + hi]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - di / 2 - markShiftFour, yi + h1i]),
          "H1ILine1": new makerjs.paths.Line([xi - w2i - markShift, yi], [xi - w2i - markShift, yi + h1i]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - wc, yc - hc - markShiftThree], [xc, yc - hc - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - w1c, yc - hc - dc - markShiftThree], [xc, yc - hc - dc - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - w2c, yc - hc - hc - dc - markShiftFour], [xc, yc - hc - hc - dc - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc + markShiftFour, yc - hc], [xc + markShiftFour, yc]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - w2c - markShiftThree, yc - h1c], [xc - w2c - markShiftThree, yc]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - w1c - markHolesOneD - markShiftFour, yc - h1c - dc - markShiftFour - markHolesOneD], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]);//D文字标注  
     
      
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - wi, yi + hi + markShiftThree], [xi, yi + hi + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - w1i, yi + hi + di + markShiftThree], [xi, yi + hi + di + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - w2i, yi + hi + hi + di + markShiftFour], [xi, yi + hi + hi + di + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi + markShiftFour, yi + hi], [xi + markShiftFour, yi]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - w2i - markShiftThree, yi + h1i], [xi - w2i - markShiftThree, yi]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - w1i - markHolesOneD - markShiftFour, yi + h1i + di + markShiftFour + markHolesOneD], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]);//D文字标注  
  
      /******************************************************************** */
      var markers = {
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "GI") {
   
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg, yg + hg], [xg, yg + hg + markShiftThree]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + wg, yg + hg], [xg + wg, yg + hg + markShiftThree]),//左上角
          "WGLine2": new makerjs.paths.Line([xg, yg + hg + markShift], [xg + wg, yg + hg + markShift]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg, yg + hg + dg + markShift], [xg + w1g, yg + hg + dg + markShift]),
          "W1GLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g, yg + h1g + dg + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg, yg + hg + hg + markShiftThree], [xg + w2g, yg + hg + hg + markShiftThree]),
          "W2GLine1": new makerjs.paths.Line([xg + w2g, yg], [xg + w2g, yg + hg + hg + dg + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg - markShiftFour, yg]),
          "HGLine1": new makerjs.paths.Line([xg, yg + hg], [xg - markShiftFour, yg + hg]),//左上角
          "HGLine2": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg + hg]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + dg / 2 + markShiftFour, yg + h1g]),
          "H1GLine1": new makerjs.paths.Line([xg + w2g + markShift, yg], [xg + w2g + markShift, yg + h1g]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + wg + (wg / 2), yg + hg], [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi, yi + hi], [xi, yi + hi + markShiftThree]),//左上角
          "WILine1": new makerjs.paths.Line([xi - wi, yi + hi], [xi - wi, yi + hi + markShiftThree]),//左上角
          "WILine2": new makerjs.paths.Line([xi, yi + hi + markShift], [xi - wi, yi + hi + markShift]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi, yi + hi + di + markShift], [xi - w1i, yi + hi + di + markShift]),
          "W1ILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i, yi + h1i + di + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi, yi + hi + hi + markShiftThree], [xi - w2i, yi + hi + hi + markShiftThree]),
          "W2ILine1": new makerjs.paths.Line([xi - w2i, yi], [xi - w2i, yi + hi + hi + di + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
          "HILine1": new makerjs.paths.Line([xi, yi + hi], [xi + markShiftFour, yi + hi]),//左上角
          "HILine2": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi + hi]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - di / 2 - markShiftFour, yi + h1i]),
          "H1ILine1": new makerjs.paths.Line([xi - w2i - markShift, yi], [xi - w2i - markShift, yi + h1i]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg, yg + hg + markShiftThree], [xg + wg, yg + hg + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg, yg + hg + dg + markShiftThree], [xg + w1g, yg + hg + dg + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg, yg + hg + hg + dg + markShiftFour], [xg + w2g, yg + hg + hg + dg + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg - markShiftFour, yg + hg], [xg - markShiftFour, yg]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg + w2g + markShiftThree, yg + h1g], [xg + w2g + markShiftThree, yg]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree], [xg + wg + (wg / 2), yg + hg]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD], [xg + w1g + markHolesOneD + markShiftFour, yg + h1g + dg + markShiftFour + markHolesOneD]);//D文字标注  
  
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - wi, yi + hi + markShiftThree], [xi, yi + hi + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - w1i, yi + hi + di + markShiftThree], [xi, yi + hi + di + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - w2i, yi + hi + hi + di + markShiftFour], [xi, yi + hi + hi + di + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi + markShiftFour, yi + hi], [xi + markShiftFour, yi]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - w2i - markShiftThree, yi + h1i], [xi - w2i - markShiftThree, yi]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - w1i - markHolesOneD - markShiftFour, yi + h1i + di + markShiftFour + markHolesOneD], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]);//D文字标注  
  
      /******************************************************************** */
      var markers = {
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "ACG") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + wa, ya - ha], [xa + wa, ya - ha - markShiftThree]),//左上角
          "WALine1": new makerjs.paths.Line([xa, ya - ha - markShift], [xa + wa, ya - ha - markShift]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa, ya - ha - da - markShift], [xa + w1a, ya - ha - da - markShift]),
          "W1ALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a, ya - h1a - da - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa + w2a, ya], [xa + w2a, ya - ra - h1a - h1a - markShiftFour]),
          "W2ALine1": new makerjs.paths.Line([xa, ya - ha - ha - markShiftThree], [xa + w2a, ya - ha - ha - markShiftThree]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa - markShiftFour, ya]),
          "HALine1": new makerjs.paths.Line([xa, ya - ha], [xa - markShiftFour, ya - ha]),//左上角
          "HALine2": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya - ha]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa + w1a - ra, ya - h1a], [xa + w2a + ra + markShiftFour, ya - h1a]),
          "H1ALine1": new makerjs.paths.Line([xa + w2a + markShift, ya], [xa + w2a + markShift, ya - h1a]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc, yc - hc], [xc, yc - hc - markShiftThree]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - wc, yc - hc], [xc - wc, yc - hc - markShiftThree]),//左上角
          "WCLine2": new makerjs.paths.Line([xc, yc - hc - markShift], [xc - wc, yc - hc - markShift]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc, yc - hc - dc - markShift], [xc - w1c, yc - hc - dc - markShift]),
          "W1CLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c, yc - h1c - dc - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc, yc - hc - hc - markShiftThree], [xc - w2c, yc - hc - hc - markShiftThree]),
          "W2CLine1": new makerjs.paths.Line([xc - w2c, yc], [xc - w2c, yc - hc - hc - dc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
          "HCLine1": new makerjs.paths.Line([xc, yc - hc], [xc + markShiftFour, yc - hc]),//左上角
          "HCLine2": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc - hc]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - dc / 2 - markShiftFour, yc - h1c]),
          "H1CLine1": new makerjs.paths.Line([xc - w2c - markShift, yc], [xc - w2c - markShift, yc - h1c]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg, yg + hg], [xg, yg + hg + markShiftThree]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + wg, yg + hg], [xg + wg, yg + hg + markShiftThree]),//左上角
          "WGLine2": new makerjs.paths.Line([xg, yg + hg + markShift], [xg + wg, yg + hg + markShift]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg, yg + hg + dg + markShift], [xg + w1g, yg + hg + dg + markShift]),
          "W1GLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g, yg + h1g + dg + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg, yg + hg + hg + markShiftThree], [xg + w2g, yg + hg + hg + markShiftThree]),
          "W2GLine1": new makerjs.paths.Line([xg + w2g, yg], [xg + w2g, yg + hg + hg + dg + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg - markShiftFour, yg]),
          "HGLine1": new makerjs.paths.Line([xg, yg + hg], [xg - markShiftFour, yg + hg]),//左上角
          "HGLine2": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg + hg]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + dg / 2 + markShiftFour, yg + h1g]),
          "H1GLine1": new makerjs.paths.Line([xg + w2g + markShift, yg], [xg + w2g + markShift, yg + h1g]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + wg + (wg / 2), yg + hg], [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD]),//左上角
        }
      };
     
      /********************************************** */
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa, ya - ha - markShiftThree], [xa + wa, ya - ha - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa, ya - ha - da - markShiftThree], [xa + w1a, ya - ha - da - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa, ya - ha - ha - ra - markShiftFour], [xa + w2a, ya - ha - ha - da - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa - markShiftFour, ya - ha], [xa - markShiftFour, ya]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa + w2a + markShiftThree, ya - h1a], [xa + w2a + markShiftThree, ya]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD], [xa + w1a + markHolesOneD + markShiftFour, ya - h1a - da - markShiftFour - markHolesOneD]);//D文字标注  
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - wc, yc - hc - markShiftThree], [xc, yc - hc - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - w1c, yc - hc - dc - markShiftThree], [xc, yc - hc - dc - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - w2c, yc - hc - hc - dc - markShiftFour], [xc, yc - hc - hc - dc - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc + markShiftFour, yc - hc], [xc + markShiftFour, yc]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - w2c - markShiftThree, yc - h1c], [xc - w2c - markShiftThree, yc]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - w1c - markHolesOneD - markShiftFour, yc - h1c - dc - markShiftFour - markHolesOneD], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]);//D文字标注  
     
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg, yg + hg + markShiftThree], [xg + wg, yg + hg + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg, yg + hg + dg + markShiftThree], [xg + w1g, yg + hg + dg + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg, yg + hg + hg + dg + markShiftFour], [xg + w2g, yg + hg + hg + dg + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg - markShiftFour, yg + hg], [xg - markShiftFour, yg]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg + w2g + markShiftThree, yg + h1g], [xg + w2g + markShiftThree, yg]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree], [xg + wg + (wg / 2), yg + hg]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD], [xg + w1g + markHolesOneD + markShiftFour, yg + h1g + dg + markShiftFour + markHolesOneD]);//D文字标注  
  
     
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
     
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
  
      }
    } else if (area == "ACI") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + wa, ya - ha], [xa + wa, ya - ha - markShiftThree]),//左上角
          "WALine1": new makerjs.paths.Line([xa, ya - ha - markShift], [xa + wa, ya - ha - markShift]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa, ya - ha - da - markShift], [xa + w1a, ya - ha - da - markShift]),
          "W1ALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a, ya - h1a - da - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa + w2a, ya], [xa + w2a, ya - ra - h1a - h1a - markShiftFour]),
          "W2ALine1": new makerjs.paths.Line([xa, ya - ha - ha - markShiftThree], [xa + w2a, ya - ha - ha - markShiftThree]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa - markShiftFour, ya]),
          "HALine1": new makerjs.paths.Line([xa, ya - ha], [xa - markShiftFour, ya - ha]),//左上角
          "HALine2": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya - ha]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa + w1a - ra, ya - h1a], [xa + w2a + ra + markShiftFour, ya - h1a]),
          "H1ALine1": new makerjs.paths.Line([xa + w2a + markShift, ya], [xa + w2a + markShift, ya - h1a]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc, yc - hc], [xc, yc - hc - markShiftThree]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - wc, yc - hc], [xc - wc, yc - hc - markShiftThree]),//左上角
          "WCLine2": new makerjs.paths.Line([xc, yc - hc - markShift], [xc - wc, yc - hc - markShift]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc, yc - hc - dc - markShift], [xc - w1c, yc - hc - dc - markShift]),
          "W1CLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c, yc - h1c - dc - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc, yc - hc - hc - markShiftThree], [xc - w2c, yc - hc - hc - markShiftThree]),
          "W2CLine1": new makerjs.paths.Line([xc - w2c, yc], [xc - w2c, yc - hc - hc - dc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
          "HCLine1": new makerjs.paths.Line([xc, yc - hc], [xc + markShiftFour, yc - hc]),//左上角
          "HCLine2": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc - hc]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - dc / 2 - markShiftFour, yc - h1c]),
          "H1CLine1": new makerjs.paths.Line([xc - w2c - markShift, yc], [xc - w2c - markShift, yc - h1c]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi, yi + hi], [xi, yi + hi + markShiftThree]),//左上角
          "WILine1": new makerjs.paths.Line([xi - wi, yi + hi], [xi - wi, yi + hi + markShiftThree]),//左上角
          "WILine2": new makerjs.paths.Line([xi, yi + hi + markShift], [xi - wi, yi + hi + markShift]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi, yi + hi + di + markShift], [xi - w1i, yi + hi + di + markShift]),
          "W1ILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i, yi + h1i + di + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi, yi + hi + hi + markShiftThree], [xi - w2i, yi + hi + hi + markShiftThree]),
          "W2ILine1": new makerjs.paths.Line([xi - w2i, yi], [xi - w2i, yi + hi + hi + di + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
          "HILine1": new makerjs.paths.Line([xi, yi + hi], [xi + markShiftFour, yi + hi]),//左上角
          "HILine2": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi + hi]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - di / 2 - markShiftFour, yi + h1i]),
          "H1ILine1": new makerjs.paths.Line([xi - w2i - markShift, yi], [xi - w2i - markShift, yi + h1i]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa, ya - ha - markShiftThree], [xa + wa, ya - ha - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa, ya - ha - da - markShiftThree], [xa + w1a, ya - ha - da - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa, ya - ha - ha - ra - markShiftFour], [xa + w2a, ya - ha - ha - da - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa - markShiftFour, ya - ha], [xa - markShiftFour, ya]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa + w2a + markShiftThree, ya - h1a], [xa + w2a + markShiftThree, ya]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD], [xa + w1a + markHolesOneD + markShiftFour, ya - h1a - da - markShiftFour - markHolesOneD]);//D文字标注  
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - wc, yc - hc - markShiftThree], [xc, yc - hc - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - w1c, yc - hc - dc - markShiftThree], [xc, yc - hc - dc - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - w2c, yc - hc - hc - dc - markShiftFour], [xc, yc - hc - hc - dc - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc + markShiftFour, yc - hc], [xc + markShiftFour, yc]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - w2c - markShiftThree, yc - h1c], [xc - w2c - markShiftThree, yc]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - w1c - markHolesOneD - markShiftFour, yc - h1c - dc - markShiftFour - markHolesOneD], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]);//D文字标注  
     
      
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - wi, yi + hi + markShiftThree], [xi, yi + hi + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - w1i, yi + hi + di + markShiftThree], [xi, yi + hi + di + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - w2i, yi + hi + hi + di + markShiftFour], [xi, yi + hi + hi + di + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi + markShiftFour, yi + hi], [xi + markShiftFour, yi]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - w2i - markShiftThree, yi + h1i], [xi - w2i - markShiftThree, yi]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - w1i - markHolesOneD - markShiftFour, yi + h1i + di + markShiftFour + markHolesOneD], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]);//D文字标注  
      
      
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "AGI") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + wa, ya - ha], [xa + wa, ya - ha - markShiftThree]),//左上角
          "WALine1": new makerjs.paths.Line([xa, ya - ha - markShift], [xa + wa, ya - ha - markShift]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa, ya - ha - da - markShift], [xa + w1a, ya - ha - da - markShift]),
          "W1ALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a, ya - h1a - da - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa + w2a, ya], [xa + w2a, ya - ra - h1a - h1a - markShiftFour]),
          "W2ALine1": new makerjs.paths.Line([xa, ya - ha - ha - markShiftThree], [xa + w2a, ya - ha - ha - markShiftThree]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa - markShiftFour, ya]),
          "HALine1": new makerjs.paths.Line([xa, ya - ha], [xa - markShiftFour, ya - ha]),//左上角
          "HALine2": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya - ha]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa + w1a - ra, ya - h1a], [xa + w2a + ra + markShiftFour, ya - h1a]),
          "H1ALine1": new makerjs.paths.Line([xa + w2a + markShift, ya], [xa + w2a + markShift, ya - h1a]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD]),//左上角
        }
      };
     
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg, yg + hg], [xg, yg + hg + markShiftThree]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + wg, yg + hg], [xg + wg, yg + hg + markShiftThree]),//左上角
          "WGLine2": new makerjs.paths.Line([xg, yg + hg + markShift], [xg + wg, yg + hg + markShift]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg, yg + hg + dg + markShift], [xg + w1g, yg + hg + dg + markShift]),
          "W1GLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g, yg + h1g + dg + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg, yg + hg + hg + markShiftThree], [xg + w2g, yg + hg + hg + markShiftThree]),
          "W2GLine1": new makerjs.paths.Line([xg + w2g, yg], [xg + w2g, yg + hg + hg + dg + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg - markShiftFour, yg]),
          "HGLine1": new makerjs.paths.Line([xg, yg + hg], [xg - markShiftFour, yg + hg]),//左上角
          "HGLine2": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg + hg]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + dg / 2 + markShiftFour, yg + h1g]),
          "H1GLine1": new makerjs.paths.Line([xg + w2g + markShift, yg], [xg + w2g + markShift, yg + h1g]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + wg + (wg / 2), yg + hg], [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi, yi + hi], [xi, yi + hi + markShiftThree]),//左上角
          "WILine1": new makerjs.paths.Line([xi - wi, yi + hi], [xi - wi, yi + hi + markShiftThree]),//左上角
          "WILine2": new makerjs.paths.Line([xi, yi + hi + markShift], [xi - wi, yi + hi + markShift]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi, yi + hi + di + markShift], [xi - w1i, yi + hi + di + markShift]),
          "W1ILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i, yi + h1i + di + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi, yi + hi + hi + markShiftThree], [xi - w2i, yi + hi + hi + markShiftThree]),
          "W2ILine1": new makerjs.paths.Line([xi - w2i, yi], [xi - w2i, yi + hi + hi + di + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
          "HILine1": new makerjs.paths.Line([xi, yi + hi], [xi + markShiftFour, yi + hi]),//左上角
          "HILine2": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi + hi]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - di / 2 - markShiftFour, yi + h1i]),
          "H1ILine1": new makerjs.paths.Line([xi - w2i - markShift, yi], [xi - w2i - markShift, yi + h1i]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa, ya - ha - markShiftThree], [xa + wa, ya - ha - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa, ya - ha - da - markShiftThree], [xa + w1a, ya - ha - da - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa, ya - ha - ha - ra - markShiftFour], [xa + w2a, ya - ha - ha - da - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa - markShiftFour, ya - ha], [xa - markShiftFour, ya]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa + w2a + markShiftThree, ya - h1a], [xa + w2a + markShiftThree, ya]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD], [xa + w1a + markHolesOneD + markShiftFour, ya - h1a - da - markShiftFour - markHolesOneD]);//D文字标注  
   
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg, yg + hg + markShiftThree], [xg + wg, yg + hg + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg, yg + hg + dg + markShiftThree], [xg + w1g, yg + hg + dg + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg, yg + hg + hg + dg + markShiftFour], [xg + w2g, yg + hg + hg + dg + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg - markShiftFour, yg + hg], [xg - markShiftFour, yg]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg + w2g + markShiftThree, yg + h1g], [xg + w2g + markShiftThree, yg]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree], [xg + wg + (wg / 2), yg + hg]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD], [xg + w1g + markHolesOneD + markShiftFour, yg + h1g + dg + markShiftFour + markHolesOneD]);//D文字标注  
  
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - wi, yi + hi + markShiftThree], [xi, yi + hi + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - w1i, yi + hi + di + markShiftThree], [xi, yi + hi + di + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - w2i, yi + hi + hi + di + markShiftFour], [xi, yi + hi + hi + di + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi + markShiftFour, yi + hi], [xi + markShiftFour, yi]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - w2i - markShiftThree, yi + h1i], [xi - w2i - markShiftThree, yi]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - w1i - markHolesOneD - markShiftFour, yi + h1i + di + markShiftFour + markHolesOneD], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]);//D文字标注  
      
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "CGI") {
   
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc, yc - hc], [xc, yc - hc - markShiftThree]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - wc, yc - hc], [xc - wc, yc - hc - markShiftThree]),//左上角
          "WCLine2": new makerjs.paths.Line([xc, yc - hc - markShift], [xc - wc, yc - hc - markShift]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc, yc - hc - dc - markShift], [xc - w1c, yc - hc - dc - markShift]),
          "W1CLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c, yc - h1c - dc - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc, yc - hc - hc - markShiftThree], [xc - w2c, yc - hc - hc - markShiftThree]),
          "W2CLine1": new makerjs.paths.Line([xc - w2c, yc], [xc - w2c, yc - hc - hc - dc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
          "HCLine1": new makerjs.paths.Line([xc, yc - hc], [xc + markShiftFour, yc - hc]),//左上角
          "HCLine2": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc - hc]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - dc / 2 - markShiftFour, yc - h1c]),
          "H1CLine1": new makerjs.paths.Line([xc - w2c - markShift, yc], [xc - w2c - markShift, yc - h1c]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg, yg + hg], [xg, yg + hg + markShiftThree]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + wg, yg + hg], [xg + wg, yg + hg + markShiftThree]),//左上角
          "WGLine2": new makerjs.paths.Line([xg, yg + hg + markShift], [xg + wg, yg + hg + markShift]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg, yg + hg + dg + markShift], [xg + w1g, yg + hg + dg + markShift]),
          "W1GLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g, yg + h1g + dg + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg, yg + hg + hg + markShiftThree], [xg + w2g, yg + hg + hg + markShiftThree]),
          "W2GLine1": new makerjs.paths.Line([xg + w2g, yg], [xg + w2g, yg + hg + hg + dg + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg - markShiftFour, yg]),
          "HGLine1": new makerjs.paths.Line([xg, yg + hg], [xg - markShiftFour, yg + hg]),//左上角
          "HGLine2": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg + hg]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + dg / 2 + markShiftFour, yg + h1g]),
          "H1GLine1": new makerjs.paths.Line([xg + w2g + markShift, yg], [xg + w2g + markShift, yg + h1g]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + wg + (wg / 2), yg + hg], [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi, yi + hi], [xi, yi + hi + markShiftThree]),//左上角
          "WILine1": new makerjs.paths.Line([xi - wi, yi + hi], [xi - wi, yi + hi + markShiftThree]),//左上角
          "WILine2": new makerjs.paths.Line([xi, yi + hi + markShift], [xi - wi, yi + hi + markShift]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi, yi + hi + di + markShift], [xi - w1i, yi + hi + di + markShift]),
          "W1ILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i, yi + h1i + di + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi, yi + hi + hi + markShiftThree], [xi - w2i, yi + hi + hi + markShiftThree]),
          "W2ILine1": new makerjs.paths.Line([xi - w2i, yi], [xi - w2i, yi + hi + hi + di + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
          "HILine1": new makerjs.paths.Line([xi, yi + hi], [xi + markShiftFour, yi + hi]),//左上角
          "HILine2": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi + hi]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - di / 2 - markShiftFour, yi + h1i]),
          "H1ILine1": new makerjs.paths.Line([xi - w2i - markShift, yi], [xi - w2i - markShift, yi + h1i]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
     /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
     makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - wc, yc - hc - markShiftThree], [xc, yc - hc - markShiftThree]);//半径文字  
     makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - w1c, yc - hc - dc - markShiftThree], [xc, yc - hc - dc - markShiftThree]);//W1文字标注 
     makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - w2c, yc - hc - hc - dc - markShiftFour], [xc, yc - hc - hc - dc - markShiftFour]);//W1文字标注
     makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc + markShiftFour, yc - hc], [xc + markShiftFour, yc]);//H文字标注
     makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - w2c - markShiftThree, yc - h1c], [xc - w2c - markShiftThree, yc]);//H1文字标注
     makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]);//R1文字标注
     makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - w1c - markHolesOneD - markShiftFour, yc - h1c - dc - markShiftFour - markHolesOneD], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]);//D文字标注  
    
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg, yg + hg + markShiftThree], [xg + wg, yg + hg + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg, yg + hg + dg + markShiftThree], [xg + w1g, yg + hg + dg + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg, yg + hg + hg + dg + markShiftFour], [xg + w2g, yg + hg + hg + dg + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg - markShiftFour, yg + hg], [xg - markShiftFour, yg]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg + w2g + markShiftThree, yg + h1g], [xg + w2g + markShiftThree, yg]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree], [xg + wg + (wg / 2), yg + hg]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD], [xg + w1g + markHolesOneD + markShiftFour, yg + h1g + dg + markShiftFour + markHolesOneD]);//D文字标注  
  
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - wi, yi + hi + markShiftThree], [xi, yi + hi + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - w1i, yi + hi + di + markShiftThree], [xi, yi + hi + di + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - w2i, yi + hi + hi + di + markShiftFour], [xi, yi + hi + hi + di + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi + markShiftFour, yi + hi], [xi + markShiftFour, yi]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - w2i - markShiftThree, yi + h1i], [xi - w2i - markShiftThree, yi]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - w1i - markHolesOneD - markShiftFour, yi + h1i + di + markShiftFour + markHolesOneD], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]);//D文字标注  
      /******************************************************************** */
      var markers = {
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
    } else if (area == "ACGI") {
      var myFsAMakerWA = {
        paths: {
          "WALine0": new makerjs.paths.Line([xa + wa, ya - ha], [xa + wa, ya - ha - markShiftThree]),//左上角
          "WALine1": new makerjs.paths.Line([xa, ya - ha - markShift], [xa + wa, ya - ha - markShift]),
        }
      };
      var myFsAMakerW1A = {
        paths: {
          "W1ALine0": new makerjs.paths.Line([xa, ya - ha - da - markShift], [xa + w1a, ya - ha - da - markShift]),
          "W1ALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a, ya - h1a - da - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2A = {
        paths: {
          "W2ALine0": new makerjs.paths.Line([xa + w2a, ya], [xa + w2a, ya - ra - h1a - h1a - markShiftFour]),
          "W2ALine1": new makerjs.paths.Line([xa, ya - ha - ha - markShiftThree], [xa + w2a, ya - ha - ha - markShiftThree]),//左上角
        }
      };
      var myFsAMakerHA = {
  
        paths: {
          "HALine0": new makerjs.paths.Line([xa, ya], [xa - markShiftFour, ya]),
          "HALine1": new makerjs.paths.Line([xa, ya - ha], [xa - markShiftFour, ya - ha]),//左上角
          "HALine2": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya - ha]),//左上角
        }
      };
      var myFsAMakerH1A = {
        paths: {
          "H1ALine0": new makerjs.paths.Line([xa + w1a - ra, ya - h1a], [xa + w2a + ra + markShiftFour, ya - h1a]),
          "H1ALine1": new makerjs.paths.Line([xa + w2a + markShift, ya], [xa + w2a + markShift, ya - h1a]),//左上角
        }
      };
      var myFsAMakerR1A = {
        paths: {
          "R1ALine1": new makerjs.paths.Line([xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDA = {
        paths: {
          "DALine1": new makerjs.paths.Line([xa + w1a, ya - h1a], [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************CCCCC */
      var myFsAMakerWC = {
        paths: {
          "WCLine0": new makerjs.paths.Line([xc, yc - hc], [xc, yc - hc - markShiftThree]),//左上角
          "WCLine1": new makerjs.paths.Line([xc - wc, yc - hc], [xc - wc, yc - hc - markShiftThree]),//左上角
          "WCLine2": new makerjs.paths.Line([xc, yc - hc - markShift], [xc - wc, yc - hc - markShift]),
        }
      };
      var myFsAMakerW1C = {
        paths: {
          "W1CLine0": new makerjs.paths.Line([xc, yc - hc - dc - markShift], [xc - w1c, yc - hc - dc - markShift]),
          "W1CLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c, yc - h1c - dc - markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2C = {
        paths: {
          "W2CLine0": new makerjs.paths.Line([xc, yc - hc - hc - markShiftThree], [xc - w2c, yc - hc - hc - markShiftThree]),
          "W2CLine1": new makerjs.paths.Line([xc - w2c, yc], [xc - w2c, yc - hc - hc - dc - markShiftFour]),//左上角
        }
      };
      var myFsAMakerHC = {
        paths: {
          "HCLine0": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
          "HCLine1": new makerjs.paths.Line([xc, yc - hc], [xc + markShiftFour, yc - hc]),//左上角
          "HCLine2": new makerjs.paths.Line([xc + markShiftTwo, yc], [xc + markShiftTwo, yc - hc]),//左上角
        }
      };
      var myFsAMakerH1C = {
        paths: {
          "H1CLine0": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - dc / 2 - markShiftFour, yc - h1c]),
          "H1CLine1": new makerjs.paths.Line([xc - w2c - markShift, yc], [xc - w2c - markShift, yc - h1c]),//左上角
        }
      };
      var myFsAMakerR1C = {
        paths: {
          "R1CLine1": new makerjs.paths.Line([xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDC = {
        paths: {
          "DCLine1": new makerjs.paths.Line([xc - w1c, yc - h1c], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]),//左上角
        }
      };
      /*******************************GGGGGG */
      var myFsAMakerWG = {
        paths: {
          "WGLine0": new makerjs.paths.Line([xg, yg + hg], [xg, yg + hg + markShiftThree]),//左上角
          "WGLine1": new makerjs.paths.Line([xg + wg, yg + hg], [xg + wg, yg + hg + markShiftThree]),//左上角
          "WGLine2": new makerjs.paths.Line([xg, yg + hg + markShift], [xg + wg, yg + hg + markShift]),
        }
      };
      var myFsAMakerW1G = {
        paths: {
          "W1GLine0": new makerjs.paths.Line([xg, yg + hg + dg + markShift], [xg + w1g, yg + hg + dg + markShift]),
          "W1GLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g, yg + h1g + dg + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2G = {
        paths: {
          "W2GLine0": new makerjs.paths.Line([xg, yg + hg + hg + markShiftThree], [xg + w2g, yg + hg + hg + markShiftThree]),
          "W2GLine1": new makerjs.paths.Line([xg + w2g, yg], [xg + w2g, yg + hg + hg + dg + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHG = {
        paths: {
          "HGLine0": new makerjs.paths.Line([xg, yg], [xg - markShiftFour, yg]),
          "HGLine1": new makerjs.paths.Line([xg, yg + hg], [xg - markShiftFour, yg + hg]),//左上角
          "HGLine2": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg + hg]),//左上角
        }
      };
      var myFsAMakerH1G = {
        paths: {
          "H1GLine0": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + dg / 2 + markShiftFour, yg + h1g]),
          "H1GLine1": new makerjs.paths.Line([xg + w2g + markShift, yg], [xg + w2g + markShift, yg + h1g]),//左上角
        }
      };
  
      var myFsAMakerR1G = {
        paths: {
          "R1GLine1": new makerjs.paths.Line([xg + wg + (wg / 2), yg + hg], [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree]),//左上角
        }
      };
      var myFsAMakerDG = {
        paths: {
          "DGLine1": new makerjs.paths.Line([xg + w1g, yg + h1g], [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /*******************************IIIIIIIIIIIII */
      var myFsAMakerWI = {
        paths: {
          "WILine0": new makerjs.paths.Line([xi, yi + hi], [xi, yi + hi + markShiftThree]),//左上角
          "WILine1": new makerjs.paths.Line([xi - wi, yi + hi], [xi - wi, yi + hi + markShiftThree]),//左上角
          "WILine2": new makerjs.paths.Line([xi, yi + hi + markShift], [xi - wi, yi + hi + markShift]),
        }
      };
      var myFsAMakerW1I = {
        paths: {
          "W1ILine0": new makerjs.paths.Line([xi, yi + hi + di + markShift], [xi - w1i, yi + hi + di + markShift]),
          "W1ILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i, yi + h1i + di + markShiftThree]),//左上角
        }
      };
      var myFsAMakerW2I = {
        paths: {
          "W2ILine0": new makerjs.paths.Line([xi, yi + hi + hi + markShiftThree], [xi - w2i, yi + hi + hi + markShiftThree]),
          "W2ILine1": new makerjs.paths.Line([xi - w2i, yi], [xi - w2i, yi + hi + hi + di + markShiftFour]),//左上角
        }
      };
      var myFsAMakerHI = {
        paths: {
          "HILine0": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
          "HILine1": new makerjs.paths.Line([xi, yi + hi], [xi + markShiftFour, yi + hi]),//左上角
          "HILine2": new makerjs.paths.Line([xi + markShiftTwo, yi], [xi + markShiftTwo, yi + hi]),//左上角
        }
      };
      var myFsAMakerH1I = {
        paths: {
          "H1ILine0": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - di / 2 - markShiftFour, yi + h1i]),
          "H1ILine1": new makerjs.paths.Line([xi - w2i - markShift, yi], [xi - w2i - markShift, yi + h1i]),//左上角
        }
      };
  
      var myFsAMakerR1I = {
        paths: {
          "R1ILine1": new makerjs.paths.Line([xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]),//左上角
        }
      };
      var myFsAMakerDI = {
        paths: {
          "DILine1": new makerjs.paths.Line([xi - w1i, yi + h1i], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]),//左上角
        }
      };
      /********************************************** */
      /**********************************************AAAAAAAAAAAAAAA */
      makerjs.model.addCaption(myFsAMakerWA, TxtWa, [xa, ya - ha - markShiftThree], [xa + wa, ya - ha - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1A, TxtW1a, [xa, ya - ha - da - markShiftThree], [xa + w1a, ya - ha - da - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2A, TxtW2a, [xa, ya - ha - ha - ra - markShiftFour], [xa + w2a, ya - ha - ha - da - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHA, TxtHa, [xa - markShiftFour, ya - ha], [xa - markShiftFour, ya]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1A, TxtH1a, [xa + w2a + markShiftThree, ya - h1a], [xa + w2a + markShiftThree, ya]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1A, TxtR1a, [xa + wa + (wa / 2), ya - ha], [xa + wa + markShiftFour, ya - ha + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDA, TxtDa, [xa + w1a + markShift + markHolesOneD, ya - h1a - da - markShiftFour - markHolesOneD], [xa + w1a + markHolesOneD + markShiftFour, ya - h1a - da - markShiftFour - markHolesOneD]);//D文字标注  
      /***************************************CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC*/
  
      makerjs.model.addCaption(myFsAMakerWC, TxtWc, [xc - wc, yc - hc - markShiftThree], [xc, yc - hc - markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1C, TxtW1c, [xc - w1c, yc - hc - dc - markShiftThree], [xc, yc - hc - dc - markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2C, TxtW2c, [xc - w2c, yc - hc - hc - dc - markShiftFour], [xc, yc - hc - hc - dc - markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHC, TxtHc, [xc + markShiftFour, yc - hc], [xc + markShiftFour, yc]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1C, TxtH1c, [xc - w2c - markShiftThree, yc - h1c], [xc - w2c - markShiftThree, yc]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1C, TxtR1c, [xc - wc - (wc / 2), yc - hc], [xc - wc - markShiftFour, yc - hc + markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDC, TxtDc, [xc - w1c - markHolesOneD - markShiftFour, yc - h1c - dc - markShiftFour - markHolesOneD], [xc - w1c - markShift - markHolesOneD, yc - h1c - dc - markShiftFour - markHolesOneD]);//D文字标注  
     
      /***************************************GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG*/
  
      makerjs.model.addCaption(myFsAMakerWG, TxtWg, [xg, yg + hg + markShiftThree], [xg + wg, yg + hg + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1G, TxtW1g, [xg, yg + hg + dg + markShiftThree], [xg + w1g, yg + hg + dg + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2G, TxtW2g, [xg, yg + hg + hg + dg + markShiftFour], [xg + w2g, yg + hg + hg + dg + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHG, TxtHg, [xg - markShiftFour, yg + hg], [xg - markShiftFour, yg]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1G, TxtH1g, [xg + w2g + markShiftThree, yg + h1g], [xg + w2g + markShiftThree, yg]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1G, TxtR1g, [xg + wg + (wg / 2) - markShiftFour, yg + hg - markShiftThree], [xg + wg + (wg / 2), yg + hg]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDG, TxtDg, [xg + w1g + markShift + markHolesOneD, yg + h1g + dg + markShiftFour + markHolesOneD], [xg + w1g + markHolesOneD + markShiftFour, yg + h1g + dg + markShiftFour + markHolesOneD]);//D文字标注  
  
      /***************************************IIIIIIIIIIIIIIIIIIIIIIIIIIIII*/
  
      makerjs.model.addCaption(myFsAMakerWI, TxtWi, [xi - wi, yi + hi + markShiftThree], [xi, yi + hi + markShiftThree]);//半径文字  
      makerjs.model.addCaption(myFsAMakerW1I, TxtW1i, [xi - w1i, yi + hi + di + markShiftThree], [xi, yi + hi + di + markShiftThree]);//W1文字标注 
      makerjs.model.addCaption(myFsAMakerW2I, TxtW2i, [xi - w2i, yi + hi + hi + di + markShiftFour], [xi, yi + hi + hi + di + markShiftFour]);//W1文字标注
      makerjs.model.addCaption(myFsAMakerHI, TxtHi, [xi + markShiftFour, yi + hi], [xi + markShiftFour, yi]);//H文字标注
      makerjs.model.addCaption(myFsAMakerH1I, TxtH1i, [xi - w2i - markShiftThree, yi + h1i], [xi - w2i - markShiftThree, yi]);//H1文字标注
      makerjs.model.addCaption(myFsAMakerR1I, TxtR1i, [xi - wi - (wi / 2), yi + hi], [xi - wi - markShiftFour, yi + hi - markShiftTwo]);//R1文字标注
      makerjs.model.addCaption(myFsAMakerDI, TxtDi, [xi - w1i - markHolesOneD - markShiftFour, yi + h1i + di + markShiftFour + markHolesOneD], [xi - w1i - markShift - markHolesOneD, yi + h1i + di + markShiftFour + markHolesOneD]);//D文字标注  
      /******************************************************************** */
      var markers = {
        myFsAMakerWA,
        myFsAMakerW1A,
        myFsAMakerW2A,
        myFsAMakerHA,
        myFsAMakerH1A,
        myFsAMakerR1A,
        myFsAMakerDA,
        /**C */
        myFsAMakerWC,
        myFsAMakerW1C,
        myFsAMakerW2C,
        myFsAMakerHC,
        myFsAMakerH1C,
        myFsAMakerR1C,
        myFsAMakerDC,
        /**G */
        myFsAMakerWG,
        myFsAMakerW1G,
        myFsAMakerW2G,
        myFsAMakerHG,
        myFsAMakerH1G,
        myFsAMakerR1G,
        myFsAMakerDG,
        /**I */
        myFsAMakerWI,
        myFsAMakerW1I,
        myFsAMakerW2I,
        myFsAMakerHI,
        myFsAMakerH1I,
        myFsAMakerR1I,
        myFsAMakerDI,
  
      }
  
  
      // var myFilletMark = new makerjs.models.ConnectTheDots(true, [[xghx, xghy], [xahx, xahy], [xawx, xawy], [xcwx, xcwy], [xchx, xchy],[xihx, xihy], [xiwx, xiwy], [xgwx, xgwy]]);
    }
} 


  return { markers };
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function FloorSpring2H(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius) {
  var frame = outParam.shapeName;
  console.log("outParam==", outParam)
  console.log("model==", model)
  console.log("inputParam==", inputParam)
  console.log("outParam.shapeName==////////", outParam.shapeName)
  var allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
  if (typeof (frame) == "undefined") {
    var D = inputParam.D, R = inputParam.R, W = inputParam.W, W1 = inputParam.W1, W2 = inputParam.W2, H = inputParam.H, H1 = inputParam.H1, X = inputParam.X, Y = inputParam.Y, area = inputParam.area, myZoom = zoom * 1, myθCut = θCut, myrCut = rCut,
      plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
      glassW = outParam.glassW*1, glassH = outParam.glassH*1,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
      markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
      markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,


      w = W * 1 * myZoom,
      w1 = W1 * 1 * myZoom,
      w2 = W2 * 1 * myZoom,
      h = H * 1 * myZoom,
      h1 = H1 * 1 * myZoom,
      r1 = R * 1 * myZoom,
      d = D * 1 * myZoom,
      r = d / 2,
      a = 0,//圆心坐标[a,b]
      b = 0;//圆心坐标[a,b]  
    x0 = X * 1 * myZoom,
      y0 = Y * 1 * myZoom;
      if(plate.models===undefined||plate.models===""){
        console.log("1111111111111111");
        plate.models={};
                }        
                if(cutPlate.models===undefined||cutPlate.models===""){
                    console.log("22222222222");
                    //cutPlate.models={};
                    cutPlate.models={};
                }
                if(markers.models===undefined||markers.models===""){            
                    console.log("333333333333");
                    markers.models={};
                }

    if (d !== 0) {
      var TxtD = "∮" + D;
    }
    if (r1 !== 0) {
      var TxtR1 = "R=" + R;
    }
    if (w !== 0) {
      var TxtW = W;
    }
    if (w1 !== 0) {
      var TxtW1 = W1;
    }
    if (w2 !== 0) {
      var TxtW2 = W2;
    }
    if (h !== 0) {
      var TxtH = H;
    }
    if (h1 !== 0) {
      var TxtH1 = H1;
    }
  } else {
    var D = inputParam.D, R = inputParam.R, W = inputParam.W, W1 = inputParam.W1, W2 = inputParam.W2, H = inputParam.H, H1 = inputParam.H1, X = inputParam.X, Y = inputParam.Y, area = inputParam.area, myZoom = zoom * 1, myθCut = θCut, myrCut = rCut,
      plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
      glassW = outParam.glassW*1, glassH = outParam.glassH*1,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
      markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
      markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,

      w = W * 1 * myZoom,
      w1 = W1 * 1 * myZoom,
      w2 = W2 * 1 * myZoom,
      h = H * 1 * myZoom,
      h1 = H1 * 1 * myZoom,
      r1 = R * 1 * myZoom,
      d = D * 1 * myZoom,
      r = d / 2,
      a = 0,//圆心坐标[a,b]
      b = 0,//圆心坐标[a,b]  
      x0 = X * 1 * myZoom,
      y0 = Y * 1 * myZoom;
      if(plate.models===undefined||plate.models===""){
        console.log("1111111111111111");
        plate.models={};
                }        
                if(cutPlate.models===undefined||cutPlate.models===""){
                    console.log("22222222222");
                    //cutPlate.models={};
                    cutPlate.models={};
                }
                if(markers.models===undefined||markers.models===""){            
                    console.log("333333333333");
                    markers.models={};
                }

    if (d !== 0) {
      var TxtD = "∮" + D;
    }
    if (r1 !== 0) {
      var TxtR1 = "R=" + R;
    }
    if (w !== 0) {
      var TxtW = W;
    }
    if (w1 !== 0) {
      var TxtW1 = W1;
    }
    if (w2 !== 0) {
      var TxtW2 = W2;
    }
    if (h !== 0) {
      var TxtH = H;
    }
    if (h1 !== 0) {
      var TxtH1 = H1;
    }
    if (x0 !== 0) {
      var TxtX = X;
    }
    if (y0 !== 0) {
      var TxtY = Y;
    }
  }
  if (frame == "Rectangle") {
    console.log("frame==undefined||||*****")

    //在A区域 计算孔的位置       
    var xa = x0, ya = glassH * 1 - y0,
      //C区域
      xc = glassW * 1 - x0, yc = glassH * 1 - y0,
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;

      if(glassW*1<glassH*1){
        console.log("长边在X轴￥￥￥￥￥");
        var xawx1 = xa+h, xawy1 = ya,//A位置角1坐标
        xawx2 = xa + h, xawy2 = ya -w ,//A位置角2坐标
        xawx3 = xa , xawy3 = ya- w2,//A位置角3坐标
        da=d,wa=w,w1a=w1,w2a=w2,ha=h,h1a=h1,ra=r,r1a=r1,  

        dc=d,wc=w,w1c=w1,w2c=w2,hc=h,h1c=h1,rc=r,r1c=r1, 
        xcwx1 = xc - h, xcwy1 = yc,//C位置角1坐标
        xcwx2 = xc - h, xcwy2 = yc - w,//C位置角2坐标
        xcwx3 = xc, xcwy3 = yc - w2,//C位置角3坐标
  
        dg=d,wg=w,w1g=w1,w2g=w2,hg=h,h1g=h1,rg=r,r1g=r1,   
        xgwx1 = xg + h, xgwy1 = yg,//G位置角1坐标
        xgwx2 = xg + h, xgwy2 = yg + w,//G位置角2坐标
        xgwx3 = xg, xgwy3 = yg + w2,//G位置角3坐标

        di=d,wi=w,w1i=w1,w2i=w2,hi=h,h1i=h1,ri=r,r1i=r1,
        xiwx1 = xi - h, xiwy1 = yi,//I位置角1坐标
        xiwx2 = xi - h, xiwy2 = yi + w,//I位置角2坐标
        xiwx3 = xi, xiwy3 = yi + w2;//I位置角3坐标

        /**
      * ox1,oy1,ox2,oy2,r1,r
      * 圆心C1坐标点   ox1=h-r1,oy1=ya-w,
      * 圆心C2坐标点   ox2=h1,oy2=ya-w1，
      * 
      * 
      */
   
         var oax1=h-r1,oay1=ya-w,oax2=h1,oay2=ya-w1,
         ocx1=xc-h+r1,ocy1=yc-w,ocx2=xc-h1,ocy2=yc-w1,
         ogx1=h-r1,ogy1=w,ogx2=h1,ogy2=w1,
         oix1=xc-h+r1,oiy1=w,oix2=xc-h1,oiy2=w1;
         console.log("oax1,oay1,oax2,oay2,r1,r==",oax1,oay1,oax2,oay2,r1,r);
         var arrCulA= getCalculatingDistance(oax1,oay1,oax2,oay2,r1,r);
         var arrCulC= getCalculatingDistance(ocx1,ocy1,ocx2,ocy2,r1,r);
         var arrCulG= getCalculatingDistance(ogx1,ogy1,ogx2,ogy2,r1,r);
         var arrCulI= getCalculatingDistance(oix1,oiy1,oix2,oiy2,r1,r);
      //d,X0,Y0
      var oAd=arrCulA.d,oAX1=arrCulA.X1,oAY1=arrCulA.Y1,oAX2=arrCulA.X2,oAY2=arrCulA.Y2,oAX3=arrCulA.X3,oAY3=arrCulA.Y3,
          oCd=arrCulC.d,oCX1=arrCulC.X1,oCY1=arrCulC.Y1,oCX2=arrCulC.X2,oCY2=arrCulC.Y2,oCX3=arrCulC.X3,oCY3=arrCulC.Y3,
          oGd=arrCulG.d,oGX1=arrCulG.X1,oGY1=arrCulG.Y1,oGX2=arrCulG.X2,oGY2=arrCulG.Y2,oGX3=arrCulG.X3,oGY3=arrCulG.Y3,
          oId=arrCulI.d,oIX1=arrCulI.X1,oIY1=arrCulI.Y1,oIX2=arrCulI.X2,oIY2=arrCulI.Y2,oIX3=arrCulI.X3,oIY3=arrCulI.Y3;
      console.log("arrCulA==|||||||||||||||||||||||||*************====",arrCulA);
      console.log("arrCulA==|||||||||||||||||||||||||********oAd,oAX1,oAY1,oAX2,oAY2,oAX3,oAY3*****====",oAd,oAX1,oAY1,oAX2,oAY2,oAX3,oAY3);
      console.log("arrCulC==|||||||||||||||||||||||||********oCd,oCX1,oCY1,oCX2,oCY2,oCX3,oCY3****====",oCd,oCX1,oCY1,oCX2,oCY2,oCX3,oCY3);
      console.log("arrCulG==|||||||||||||||||||||||||********oGd,oGX1,oGY1,oGX2,oGY2,oGX3,oGY3*****====",oGd,oGX1,oGY1,oGX2,oGY2,oGX3,oGY3);
      console.log("arrCulC==|||||||||||||||||||||||||********oId,oIX1,oIY1,oIX2,oIY2,oIX3,oIY3*****====",oId,oIX1,oIY1,oIX2,oIY2,oIX3,oIY3);
  
  }else{
        console.log("短边在X轴￥￥￥￥￥");
        var xawx1 = xa, xawy1 = ya - h,//A位置角1坐标
        xawx2 = xa + w, xawy2 = ya - h,//A位置角2坐标
        xawx3 = xa + w2, xawy3 = ya,//A位置角3坐标
        da=d,wa=w,w1a=w1,w2a=w2,ha=h,h1a=h1,ra=r,r1a=r1,  
  
        dc=d,wc=w,w1c=w1,w2c=w2,hc=h,h1c=h1,rc=r,r1c=r1, 
        xcwx1 = xc, xcwy1 = yc - h,//C位置角1坐标
        xcwx2 = xc - w, xcwy2 = yc - h,//C位置角2坐标
        xcwx3 = xc - w2, xcwy3 = yc,//C位置角3坐标
  
        dg=d,wg=w,w1g=w1,w2g=w2,hg=h,h1g=h1,rg=r,r1g=r1,   
        xgwx1 = xg, xgwy1 = yg + h,//G位置角1坐标
        xgwx2 = xg + w, xgwy2 = yg + h,//G位置角2坐标
        xgwx3 = xg + w2, xgwy3 = yg,//G位置角3坐标

   di=d,wi=w,w1i=w1,w2i=w2,hi=h,h1i=h1,ri=r,r1i=r1,
        xiwx1 = xi, xiwy1 = yi + h,//I位置角1坐标
        xiwx2 = xi - w, xiwy2 = yi + h,//I位置角2坐标
        xiwx3 = xi - w2, xiwy3 = yi;//I位置角3坐标

        
     /**
      * ox1,oy1,ox2,oy2,r1,r
      * 圆心C1坐标点   ox1=h-r1,oy1=ya-w,
      * 圆心C2坐标点   ox2=h1,oy2=ya-w1，
      * 
      * 
      */
      var oax1=w,oay1=ya+r1-h,oax2=w1,oay2=ya-h1,
      ocx1=xc-w,ocy1=yc-h+r1,ocx2=xc-w1,ocy2=yc-h1,
      ogx1=w,ogy1=h-r1,ogx2=w1,ogy2=h1,
      oix1=xi-w,oiy1=h-r1,oix2=xi-w1,oiy2=h1;
      console.log("oax1,oay1,oax2,oay2,r1,r==",oax1,oay1,oax2,oay2,r1,r);
      var arrCulA= getCalculatingDistance(oax1,oay1,oax2,oay2,r1,r);
      var arrCulC= getCalculatingDistance(ocx1,ocy1,ocx2,ocy2,r1,r);
      var arrCulG= getCalculatingDistance(ogx1,ogy1,ogx2,ogy2,r1,r);
      var arrCulI= getCalculatingDistance(oix1,oiy1,oix2,oiy2,r1,r);
   //d,X0,Y0
   var oAd=arrCulA.d,oAX1=arrCulA.X1,oAY1=arrCulA.Y1,oAX2=arrCulA.X2,oAY2=arrCulA.Y2,oAX3=arrCulA.X3,oAY3=arrCulA.Y3,
       oCd=arrCulC.d,oCX1=arrCulC.X1,oCY1=arrCulC.Y1,oCX2=arrCulC.X2,oCY2=arrCulC.Y2,oCX3=arrCulC.X3,oCY3=arrCulC.Y3,
       oGd=arrCulG.d,oGX1=arrCulG.X1,oGY1=arrCulG.Y1,oGX2=arrCulG.X2,oGY2=arrCulG.Y2,oGX3=arrCulG.X3,oGY3=arrCulG.Y3,
       oId=arrCulI.d,oIX1=arrCulI.X1,oIY1=arrCulI.Y1,oIX2=arrCulI.X2,oIY2=arrCulI.Y2,oIX3=arrCulI.X3,oIY3=arrCulI.Y3;
  }

     
    // var OffsetParam={Aa,Aaa,Ahd,Ca,Caa,Chd,Ga,Gaa,Ghd,Ia,Iaa,Ihd};
  } else if (frame == "IsoscelesTrapezoid") {
    //在A区域 计算孔的位置
    var xwd = (glassW * 1 - glassW1 * 1) / 2,
      xa = x0 + xwd, ya = glassH * 1 - y0,
      awd = xwd * h / (glassH * 1),
      cwd = awd,
      xawx = xa + w, xawy = ya,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标   
      //C区域
      xc = glassW * 1 - xwd - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc,//C位置角W坐标
      xchx = xc + awd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + awd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi - awd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd, ahd: 0, cwd, cwdd: 0, chd: 0, iwd: awd, iwdd: 0, ihd: 0 };
  } else if (frame == "RightAngledTrapezoid") {
    //在A区域 计算孔的位置
    var yhd = glassH * 1 - glassH1 * 1, xwd = glassW * 1 - glassW1 * 1,
      ahd = yhd * w / (glassW1 * 1),//Y方向偏移
      awd = ((glassW1 * 1) - w) * yhd / (glassH * 1), //X方向偏移
      iwd = xwd * h / (glassH * 1), //X方向偏移
      xa = x0, ya = glassH * 1 - y0 - yhd,
      xawx = xa + w, xawy = ya + ahd,//A位置角W坐标
      xahx = xa, xahy = ya - h,//A位置角H坐标 
      //C区域
      xc = glassW * 1 - xwd - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc - ahd,//C位置角W坐标
      xchx = xc + iwd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi - iwd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd: 0, ahd, cwd: iwd, cwdd: 0, chd: 0, iwd, iwdd: 0, ihd: 0 };
  } else if (frame == "OtherTrapezoidsA") {
    //在A区域 计算孔的位置
    var yhd = glassH1 * 1 - glassH2 * 1,
      ahd = yhd * w / ((glassW * 1) - (glassW1 * 1) - (glassW2 * 1)),//Y方向偏移
      awd = (glassW1 * 1) * h / (glassH1 * 1), //X方向偏移 A 
      iwd = (glassW2 * 1) * h / (glassH2 * 1), //X方向偏移
      gwd = (glassW1 * 1) * h / (glassH1 * 1), //X方向偏移


      xa = x0 + glassW1 * 1, ya = glassH1 * 1 - y0,
      xawx = xa + w, xawy = ya - ahd,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标 
      //C区域
      xc = glassW * 1 - glassW2 * 1 - x0, yc = glassH2 * 1 - y0,
      xcwx = xc - w, xcwy = yc + ahd,//C位置角W坐标
      xchx = xc + iwd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + gwd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi - iwd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd: 0, ahd: 0, cwd: iwd, cwdd: 0, chd: ahd, iwd, iwdd: 0, ihd: 0 };
  } else if (frame == "OtherTrapezoidsB") {
    //在A区域 计算孔的位置
    var yhd = glassH1 * 1 - glassH2 * 1,
      ahd = yhd * w / ((glassW * 1) - (glassW1 * 1) - (glassW2 * 1)),//Y方向偏移
      awd = (glassW1 * 1) * h / (glassH * 1), //X方向偏移 A 
      cwd = (glassW2 * 1) * h / (glassH * 1), //X方向偏移 A 
      iwd = (glassW2 * 1) * h / (glassH2 * 1), //X方向偏移
      gwd = (glassW1 * 1) * h / (glassH1 * 1), //X方向偏移
      xa = x0 + glassW1 * 1, ya = glassH * 1 - y0,
      xawx = xa + w, xawy = ya,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标
      //C区域
      xc = glassW * 1 - glassW2 * 1 - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc,//C位置角W坐标
      xchx = xc + cwd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + awd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi - cwd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd: 0, ahd: 0, cwd, cwdd: 0, chd: 0, iwd: cwd, iwdd: 0, ihd: 0 };
  } else if (frame == "ParallelogramA") {
    //在A区域 计算孔的位置
    var awd = (glassW1 * 1) * h / (glassH * 1), //X方向偏移 A
      xa = x0 + glassW1 * 1, ya = glassH * 1 - y0,
      xawx = xa + w, xawy = ya,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标
      //C区域
      xc = glassW * 1 + glassW1 * 1 - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc,//C位置角W坐标
      xchx = xc - awd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + awd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi + awd, xihy = yi + h;//I位置角H坐标

    var OffsetParam = { awd: 0, ahd: 0, cwd: 0, cwdd: awd, chd: 0, iwd: 0, iwdd: awd, ihd: 0 };

  } else if (frame == "ParallelogramB") {
    console.log("markers.models=", markers.models)
    //在A区域 计算孔的位置
    var awd = (glassW1 * 1) * h / (glassH * 1), //X方向偏移 A  G
      cwd = (glassW2 * 1) * h / (glassH * 1), //X方向偏移 C  I 
      xa = x0 + glassW1 * 1, ya = glassH * 1 - y0,
      xawx = xa + w, xawy = ya,//A位置角W坐标
      xahx = xa - awd, xahy = ya - h,//A位置角H坐标
      //C区域
      xc = glassW * 1 + glassW2 * 1 - x0, yc = glassH * 1 - y0,
      xcwx = xc - w, xcwy = yc,//C位置角W坐标
      xchx = xc - cwd, xchy = yc - h,//C位置角H坐标
      //在G区域 计算孔的位置
      xg = x0, yg = y0,
      xgwx = xg + w, xgwy = yg,//G位置角W坐标
      xghx = xg + awd, xghy = yg + h,//G位置角H坐标
      //在I区域 计算孔的位置
      xi = glassW * 1 - x0, yi = y0;
    xiwx = xi - w, xiwy = yi,//I位置角W坐标
      xihx = xi + cwd, xihy = yi + h;//I位置角H坐标
    var OffsetParam = { awd: 0, ahd: 0, cwd: 0, cwdd: awd, chd: 0, iwd: 0, iwdd: cwd, ihd: 0 };

  }

  if(inputParam.area===undefined){
    var ObliqueAngleData=showArea(inputParam,outParam);
    var paramCoordinate =ObliqueAngleData[1];
    var areaPoint =ObliqueAngleData[0];
    var whMarksParam=ObliqueAngleData[2];
    console.log("whMarksParam=",whMarksParam);
  }else{
// 坐标参数
var paramCoordinate = {cutLine,cutFilletRadius,da,wa,w1a,w2a,ha,h1a,ra,r1a,dc,wc,w1c,w2c,hc,h1c,rc,r1c,dg,wg,w1g,w2g,hg,h1g,rg,r1g,di,wi,w1i,w2i,hi,h1i,ri,r1i,xa, ya, xawx1, xawy1,xawx2, xawy2,xawx3, xawy3,xc, yc, xcwx1, xcwy1, xcwx2,xcwy2,xcwx3,xcwy3,xg, yg, xgwx1, xgwy1, xgwx2, xgwy2,xgwx3, xgwy3,xi, yi, xiwx1, xiwy1, xiwx2, xiwy2, xiwx3, xiwy3,glassW,glassH,oAd,oAX1,oAY1,oAX2,oAY2,oAX3,oAY3,oCd,oCX1,oCY1,oCX2,oCY2,oCX3,oCY3,oGd,oGX1,oGY1,oGX2,oGY2,oGX3,oGY3,oId,oIX1,oIY1,oIX2,oIY2,oIX3,oIY3};
var whMarksParam={};

var areaPoint = "";
console.log("//画1、斜角 ------", allKeys)

// if (getCommonAll(allKeys,frame).length == 0) {
  switch (area) {
    case "1": areaPoint = "A"; break;
    case "3": areaPoint = "C"; break;
    case "7": areaPoint = "G"; break;
    case "9": areaPoint = "I"; break;
  }
// } else {
//   switch (area) {
//     case "1": areaPoint = getStrs("A", getCommonAll(allKeys,frame)); break;
//     case "3": areaPoint = getStrs("C", getCommonAll(allKeys,frame)); break;
//     case "7": areaPoint = getStrs("G", getCommonAll(allKeys,frame)); break;
//     case "9": areaPoint = getStrs("I", getCommonAll(allKeys,frame)); break;
//   }
// }
  }

  
  /**
  * 画图
  * 
  */
  var ObjName = "myFloorSpring2H" + areaPoint;
  var ObjNameM = "myFloorSpring2H" + areaPoint + "Mark";//外框标记
  var ObjNameMFloorSpring2H = "myFloorSpring2H" + areaPoint + "Mark";//角标记
  var ObjNameO = "myFloorSpring2H" + areaPoint + "Obj";
  ObjName = creatFloorSpring2H(areaPoint, paramCoordinate);//图形
  console.log("ObjName===|||||||||", ObjName);
  ObjNameMFloorSpring2H = creatFloorSpring2HMark(outParam, areaPoint, paramCoordinate, whMarksParam, fixedParam, OffsetParam, zoom);//图形
  console.log("ObjNameMFloorSpring2H===|||||||||角标注", ObjNameMFloorSpring2H);
  ObjNameO = { ObjName:ObjName[2] };
  ObjNameM = RectangleMark(outParam, model, fixedParam, zoom, frame);//外框标记
  // cutPlate.models = {};
  // plate.models = {};
  // markers.models = {};
  // delete markers.models.Rectangle;
  // delete markers.models.RectMarkWLine;
  // delete markers.models.RectMarkH;
  
  cutPlate.models["TypeCorner_myFloorSpring2H" + areaPoint] = ObjName[3];
  plate.models["TypeCorner_myFloorSpring2H" + areaPoint] = ObjName[3];
  console.log("ObjNameM.markers.models===|||||||||是否有所有标注", ObjNameM.markers.models);
  console.log("ObjNameMCorner.markers===|||||||||是否有所有标注", ObjNameMFloorSpring2H.markers);
  markers.models = { ...ObjNameM.markers.models,...markers.models, ...ObjNameMFloorSpring2H.markers,...plate.models};
  console.log("markers===|||||||||是否有所有标注", markers);
  myHolesNum++;
  return { plate, cutPlate, markers, myHolesNum }
};
export default FloorSpring2H;